<template>
  <div>
    <div class="detalheProposta" v-if="dadosProposta">
      <div class="text-right flex justify-end pr-2">
        <router-link
          v-if="functions.verificaEmpresaBemProtege(idEmpresa)"
          :to="`/contratoAdesao/${dadosProposta.chave}`"
          target="_blank"
        >
          <vs-button
            v-tooltip="'Contrato de Adesao'"
            color="success"
            type="gradient"
            icon-pack="feather"
            icon="icon-file-text"
            class="mr-3 mb-2 btn-print"
          >
          </vs-button>
        </router-link>

        <router-link
          v-if="functions.verificaEmpresaBemProtege(idEmpresa)"
          :to="`/laudoVistoria/${dadosProposta.chave}`"
          target="_blank"
        >
          <vs-button
            v-tooltip="'Laudo de Vistoria'"
            color="primary"
            type="gradient"
            icon-pack="feather"
            icon="icon-folder"
            class="mr-3 mb-2 btn-print"
          >
          </vs-button>
        </router-link>

        <vs-button
          v-if="$can($actionsDefault.Escrita, subjectPermission)"
          v-tooltip="'Situação Financeira'"
          color="success"
          type="gradient"
          icon-pack="feather"
          icon="icon-dollar-sign"
          class="mr-3 mb-2 btn-print"
          @click="situacaoFinanceira('Financeiro')"
        >
        </vs-button>

        <vs-button
          v-if="
            ['118', '119', '120'].includes(idEmpresa) &&
            this.$can('Notificar Associado Híbrido', this.subjectPermission)
          "
          v-tooltip="'Verificar Beneficiário na Base Antiga'"
          color="success"
          type="gradient"
          icon-pack="feather"
          icon="icon-users"
          class="mr-3 mb-2 btn-print"
          @click.stop.prevent="
            openModalVeiculosEmpresaAntiga(
              dadosProposta.dadosCliente.idProspect,
              'listarHibridos',
            )
          "
        >
        </vs-button>

        <vs-button
          v-if="$can($actionsDefault.Escrita, subjectPermission)"
          @click="editarProposta()"
          icon-pack="feather"
          icon="icon-edit-2"
          color="warning"
          type="gradient"
          class="mr-3 mb-2 btn-print"
          v-tooltip="'Editar Dados da Proposta'"
        >
        </vs-button>

        <vs-button
          v-tooltip="'Imprimir / Salvar PDF'"
          color="primary"
          type="gradient"
          class="mr-3 mb-2 btn-print"
          @click="print"
          icon-pack="feather"
          icon="icon-printer"
        >
        </vs-button>

        <vs-button
          v-if="
            $can('Visualizar Logs', subjectPermission) &&
            dadosProposta.dataSincronizacaoSga
          "
          v-tooltip="'Logs da Sincronização'"
          color="dark"
          type="gradient"
          class="mr-3 mb-2 btn-print"
          @click="exibeLogs()"
          icon-pack="feather"
          icon="icon-activity"
        >
        </vs-button>
      </div>

      <div
        v-if="
          (dadosProposta.idStatus == 6 || dadosProposta.idStatus == 5) &&
          exibirDetalhesVistoria
        "
      >
        <vs-card>
          <vs-alert color="danger" icon="new_releases">
            <span><b>Atenção: vistoria enviada com pendência!</b></span>
          </vs-alert>

          <div class="flex flex-wrap gap-2">
            <div
              v-for="item in itensNaoValidadosVistoria"
              :key="item.key"
              class="vs-col"
            >
              <vs-list>
                <vs-list-header
                  :icon="item.icon"
                  :title="item.title"
                  color="warning"
                ></vs-list-header>
                <vs-list-item
                  v-for="prop in item.propriedades"
                  :key="`${item.key}-${prop}`"
                  icon="close"
                  :title="prop"
                ></vs-list-item>
              </vs-list>
            </div>
          </div>
        </vs-card>
      </div>

      <div v-if="dadosProposta" class="printer">
        <div class="folha">
          <div slot="header">
            <center>
              <img :src="logo" style="max-width: 300px" />
              <Br />
              <Br />
            </center>
            <h3>Dados da Proposta sdfsdsdf</h3>
            <br />
          </div>
          <div>
            <table class="table table-bordered">
              <tr v-if="dadosProposta.idFrota">
                <th class="uppercase">Id Diversos</th>
                <td>{{ dadosProposta.idFrota }}</td>
              </tr>
              <tr>
                <th class="uppercase">Código da Proposta</th>
                <td>{{ dadosProposta.idProposta }}</td>
              </tr>
              <tr>
                <th class="uppercase">Tipo</th>
                <td>
                  {{
                    dadosProposta.tipoProposta === 'Adesão'
                      ? 'Contratação'
                      : dadosProposta.tipoProposta
                  }}
                </td>
              </tr>
              <tr v-if="dadosProposta.placaSubstituicao">
                <th class="uppercase">Placa Substituição</th>
                <td>
                  <p>{{ dadosProposta.placaSubstituicao }}</p>
                </td>
              </tr>
              <tr>
                <th class="uppercase">Status</th>
                <td>
                  {{ dadosProposta.nomeStatus }}
                  <span v-if="dadosProposta.dataAdesao">{{
                    formataData(dadosProposta.dataAdesao)
                  }}</span>
                </td>
              </tr>

              <tr v-if="dadosProposta.id_motivo_recusa === 7">
                <th class="uppercase">Observação de recusa</th>
                <td>
                  {{ dadosProposta.obsRecusa }}
                </td>
              </tr>

              <tr v-if="dadosProposta.qtdRecusa">
                <th class="uppercase">Proposta Reprovada</th>
                <td>
                  <p class="p-3">
                    {{
                      dadosProposta.qtdRecusa > 1
                        ? dadosProposta.qtdRecusa + ' vezes'
                        : dadosProposta.qtdRecusa + ' vez'
                    }}
                  </p>
                </td>
              </tr>

              <tr v-if="dadosProposta.motivoReprovacaoGeral">
                <th class="uppercase">Motivo Reprovação</th>
                <td>
                  <p class="bg-danger text-white p-3">
                    {{ dadosProposta.motivoReprovacaoGeral }}
                  </p>
                </td>
              </tr>

              <tr>
                <th class="uppercase">Data da Proposta</th>
                <td>{{ ajustaDataHoraUtc(dadosProposta.createdAt) }}</td>
              </tr>
              <tr v-if="dadosProposta.dataVistoria">
                <th class="uppercase">Data da Vistoria</th>
                <td>{{ ajustaDataHoraUtc(dadosProposta.dataVistoria) }}</td>
              </tr>
              <tr>
                <th class="uppercase">Origem</th>
                <td>{{ dadosProposta.origem }}</td>
              </tr>
              <!-- <tr>
                <th class="uppercase">Origem do Lead</th>
                <td>{{ dadosProposta.nomeOrigemLead }}</td>
              </tr> -->
              <tr v-if="dadosProposta.cotaTabela">
                <th class="uppercase">Cota Tabela</th>
                <td>{{ dadosProposta.cotaTabela }}</td>
              </tr>
              <tr v-if="dadosProposta.produtos">
                <th class="uppercase">Produtos</th>
                <td>
                  <p v-for="item in dadosProposta.produtos" :key="item.id">
                    {{ item.nomeProduto }} ( {{ item.valor | currency }}
                    <span v-if="item.isMensal == true">/mês</span>)
                    <span v-if="item.nomePagamento"
                      >- {{ item.nomePagamento }}</span
                    >
                  </p>
                </td>
              </tr>
              <tr>
                <th class="uppercase">Observação</th>
                <td>
                  {{ dadosProposta.observacao }}
                </td>
              </tr>
              <tr>
                <th class="uppercase">Valor Mensal</th>
                <td>
                  {{ somaValorTotalMes(dadosProposta.produtos) | currency }},
                  vencimento todo dia
                  {{ dadosProposta.diaVencimentoMensalidade }}
                </td>
              </tr>
              <tr>
                <th class="uppercase">Valor Entrada</th>
                <td>{{ somaValorTotal(dadosProposta.produtos) | currency }}</td>
              </tr>
              <tr v-if="dadosProposta.ipAceite">
                <th class="uppercase">Ip</th>
                <td>{{ dadosProposta.ipAceite }}</td>
              </tr>
              <tr v-if="dadosProposta.cupom">
                <th class="uppercase">Cupom Utilizado</th>
                <td>{{ dadosProposta.cupom }}</td>
              </tr>
              <!-- <tr v-if="travaFinalizarPropostaSemApolice">
                <th class="uppercase">Apólice</th>
                <td v-if="dadosProposta.numeroApolice">
                  {{ dadosProposta.numeroApolice }}
                </td>
                <td v-else class="bg-danger text-white">
                  Sem apólice vinculada
                </td>
              </tr> -->
            </table>
          </div>
        </div>
        <div class="folha">
          <div slot="header">
            <h3>Beneficiário</h3>
            <br />
          </div>
          <div>
            <table
              class="table table-bordered"
              v-if="dadosProposta.dadosCliente"
            >
              <tr>
                <th class="uppercase">Nome</th>
                <td>{{ dadosProposta.dadosCliente.associado }}</td>
              </tr>
              <tr>
                <th class="uppercase">Email</th>
                <td>{{ dadosProposta.dadosCliente.email }}</td>
              </tr>
              <tr>
                <th class="uppercase">Telefone</th>
                <td>{{ dadosProposta.dadosCliente.telefone }}</td>
              </tr>
              <tr>
                <th class="uppercase">Endereço</th>
                <td>
                  {{ dadosProposta.dadosCliente.cep }}
                  -
                  {{ dadosProposta.dadosCliente.endereco }}
                  {{ dadosProposta.dadosCliente.numero }}
                  {{ dadosProposta.dadosCliente.complemento }}
                  -
                  {{ dadosProposta.dadosCliente.bairro }}
                  -
                  {{ dadosProposta.dadosCliente.cidade }} /
                  {{ dadosProposta.dadosCliente.estado }}
                </td>
              </tr>
              <tr>
                <th class="uppercase">Tipo</th>
                <td>{{ dadosProposta.dadosCliente.tipo }}</td>
              </tr>
              <tr>
                <th class="uppercase">
                  {{
                    dadosProposta.dadosCliente.tipo == 'Pessoa Física'
                      ? 'CPF'
                      : 'CNPJ'
                  }}
                </th>
                <td>{{ dadosProposta.dadosCliente.cpf }}</td>
              </tr>
              <tr>
                <th class="uppercase">
                  {{
                    dadosProposta.dadosCliente.tipo == 'Pessoa Física'
                      ? 'RG'
                      : 'IE'
                  }}
                </th>
                <td>{{ dadosProposta.dadosCliente.rg_ie }}</td>
              </tr>
              <tr v-if="dadosProposta.dadosCliente.representanteLegal">
                <th class="uppercase">Representante Legal</th>
                <td>
                  {{ dadosProposta.dadosCliente.representanteLegal }} CPF:
                  {{ dadosProposta.dadosCliente.cpfRepresentante }}
                </td>
              </tr>
              <tr>
                <th class="uppercase">Data de Nascimento</th>
                <td>{{ dadosProposta.dadosCliente.dataNascimento }}</td>
              </tr>
              <tr>
                <th class="uppercase">CNH</th>
                <td>
                  {{ dadosProposta.dadosCliente.cnh }} ({{
                    dadosProposta.dadosCliente.catCnh
                  }})
                  <br />
                  Vencimento {{ dadosProposta.dadosCliente.dataVencimentoCnh }}
                </td>
              </tr>
              <tr>
                <th class="uppercase">Assinatura</th>
                <td>
                  <img :src="dadosProposta.assinatura" class="assinatura" />
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="folha">
          <div slot="header">
            <h3>Veículo</h3>
            <br />
          </div>
          <div>
            <table
              class="table table-bordered"
              v-if="dadosProposta.dadosVeiculo"
            >
              <tr v-if="dadosProposta.isZero">
                <th class="uppercase">Zero KM</th>
                <td>
                  NF: {{ dadosProposta.nf }}
                  <Br />
                  Data:{{ dadosProposta.dataNf }}
                  <br />
                  valor: {{ dadosProposta.valorNf | currency }}
                </td>
              </tr>
              <tr v-if="dadosProposta.nomeGrupo">
                <th class="uppercase">Grupo</th>
                <td>{{ dadosProposta.nomeGrupo }}</td>
              </tr>
              <tr v-if="dadosProposta.nomeClassificacao">
                <th class="uppercase">Classificação</th>
                <td>{{ dadosProposta.nomeClassificacao }}</td>
              </tr>
              <tr v-if="dadosProposta.dadosVeiculo.veiculoMarca">
                <th class="uppercase">Marca</th>
                <td>{{ dadosProposta.dadosVeiculo.veiculoMarca }}</td>
              </tr>
              <tr v-if="dadosProposta.dadosVeiculo.veiculoModelo">
                <th class="uppercase">Modelo</th>
                <td>{{ dadosProposta.dadosVeiculo.veiculoModelo }}</td>
              </tr>
              <tr v-if="dadosProposta.dadosVeiculo.anoFabricacao">
                <th class="uppercase">Ano</th>
                <td>
                  {{
                    dadosProposta.dadosVeiculo.anoFabricacao == '32000'
                      ? '0Km'
                      : `${dadosProposta.dadosVeiculo.anoFabricacao} / ${dadosProposta.dadosVeiculo.anoModelo}`
                  }}
                </td>
              </tr>
              <tr v-if="dadosProposta.dadosVeiculo.placa">
                <th class="uppercase">Placa</th>
                <td>{{ dadosProposta.dadosVeiculo.placa }}</td>
              </tr>
              <tr v-if="dadosProposta.dadosVeiculo.renavam">
                <th class="uppercase">Renavam</th>
                <td>{{ dadosProposta.dadosVeiculo.renavam }}</td>
              </tr>
              <tr v-if="dadosProposta.dadosVeiculo.chassi">
                <th class="uppercase">Chassi</th>
                <td style="text-transform: uppercase">
                  {{ dadosProposta.dadosVeiculo.chassi }}
                </td>
              </tr>
              <tr v-if="dadosProposta.dadosVeiculo.combustivel">
                <th class="uppercase">Combustível</th>
                <td>{{ dadosProposta.dadosVeiculo.combustivel }}</td>
              </tr>
              <tr v-if="dadosProposta.dadosVeiculo.cilindradas">
                <th class="uppercase">Cilindrada</th>
                <td>{{ dadosProposta.dadosVeiculo.cilindradas }}</td>
              </tr>
              <tr v-if="dadosProposta.dadosVeiculo.codigoFipe">
                <th class="uppercase">Código Fipe</th>
                <td>{{ dadosProposta.dadosVeiculo.codigoFipe }}</td>
              </tr>
              <tr v-if="dadosProposta.dadosVeiculo.cor">
                <th class="uppercase">Cor</th>
                <td>{{ dadosProposta.dadosVeiculo.cor }}</td>
              </tr>
              <tr v-if="dadosProposta.dadosVeiculo.estadoPneu">
                <th class="uppercase">Estado do Pneu</th>
                <td>{{ dadosProposta.dadosVeiculo.estadoPneu }}</td>
              </tr>
              <tr>
                <th class="uppercase">km</th>
                <td>{{ dadosProposta.dadosVeiculo.km }}</td>
              </tr>
              <tr v-if="dadosProposta.dadosVeiculo.valorFipe">
                <th class="uppercase">Valor</th>
                <td>{{ dadosProposta.dadosVeiculo.valorFipe | currency }}</td>
              </tr>
              <tr v-if="dadosProposta.dadosVeiculo.valorCobertura">
                <th class="uppercase">Valor Cobertura</th>
                <td>
                  {{ dadosProposta.dadosVeiculo.valorCobertura | currency }}
                </td>
              </tr>
              <tr v-if="dadosProposta.restricoes.length > 0">
                <th class="uppercase">Restrições</th>
                <td>
                  <p v-for="item in dadosProposta.restricoes" :key="item.id">
                    {{ item.descricao }}
                  </p>
                </td>
              </tr>
              <tr v-if="dadosProposta.acessorios.length > 0">
                <th class="uppercase">Acessórios</th>
                <td>
                  <p>
                    {{
                      dadosProposta.acessorios
                        .map((el) => {
                          return ' ' + el.descricao;
                        })
                        .toString()
                    }}
                  </p>
                </td>
              </tr>
              <tr v-if="dadosProposta.detalhesAcessorios">
                <th class="uppercase">Defeitos</th>
                <td>{{ dadosProposta.detalhesAcessorios }}</td>
              </tr>
            </table>
          </div>
        </div>
        <div v-for="item in filtraFotos()" :key="item.id" class="folha">
          <h3>{{ item.nomePosicao }}</h3>
          <div v-if="item.endereco" class="m-2 mb-4" style="clear: both">
            {{ item.endereco.road }} - {{ item.endereco.neighbourhood }}
            {{ item.endereco.city }} / {{ item.endereco.state }}
          </div>
          <br />
          <h5 v-if="!item.aprovada" class="mb-3">
            Reprovada - {{ item.motivoReprovacao }}
          </h5>
          <br />
          <img
            :src="item.nome"
            class="foto"
            width="100%"
            style="max-height: 940px"
          />
        </div>
      </div>
      <div class="non-printer">
        <vs-row class="flex items-start" v-if="dadosProposta">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="4"
            vs-sm="4"
            vs-xs="12"
          >
            <vs-card>
              <div slot="header">
                <h3>{{ $t('Dados') }} {{ $t('da') }} {{ $t('Proposta') }}</h3>
              </div>
              <div>
                <table class="table table-bordered">
                  <tr v-if="dadosProposta.idFrota">
                    <th class="uppercase">{{ $t('Id') }} {{ $t('Diversos') }}</th>
                    <td>{{ dadosProposta.idFrota }}</td>
                  </tr>
                  <tr>
                    <th class="uppercase">{{ $t('Código') }} {{ $t('da') }} {{ $t('Proposta') }}</th>
                    <td>{{ dadosProposta.idProposta }}</td>
                  </tr>
                  <tr>
                    <th class="uppercase">{{ $t('Tipo') }}</th>
                   <td>
                     {{
                       dadosProposta.tipoProposta === 'Adesão'
                         ? $t('Contratação')
                         : dadosProposta.tipoProposta
                     }}
                   </td>
                  </tr>
                  <tr v-if="dadosProposta.placaSubstituicao">
                    <th class="uppercase">{{ $t('Placa') }} {{ $t('Substituição') }}</th>
                    <td>
                      <p>{{ dadosProposta.placaSubstituicao }}</p>
                    </td>
                  </tr>
                  <tr>
                    <th class="uppercase">{{ $t('Status') }}</th>
                    <td>
                      {{ dadosProposta.nomeStatus }}
                      <span v-if="dadosProposta.dataAdesao">{{
                        ajustaDataHoraUtc(dadosProposta.dataAdesao)
                      }}</span>
                    </td>
                  </tr>

                  <tr v-if="dadosProposta.id_motivo_recusa === 7">
                    <th class="uppercase">{{ $t('Observação') }} {{ $t('de') }} {{ $t('recusa') }}</th>
                    <td>
                      {{ dadosProposta.obsRecusa }}
                    </td>
                  </tr>

                  <tr v-if="dadosProposta.qtdRecusa">
                    <th class="uppercase">{{ $t('Proposta') }} {{ $t('Reprovada') }}</th>
                    <td>
                      {{
                        `${dadosProposta.qtdRecusa} vez${
                          dadosProposta.qtdRecusa > 1 ? 'es' : ''
                        }`
                      }}
                    </td>
                  </tr>

                  <tr v-if="dadosProposta.motivoReprovacaoGeral">
                    <th class="uppercase">{{ $t('Motivo') }} {{ $t('Reprovação') }}</th>
                    <td>
                      <p class="bg-danger text-white p-3">
                        {{ dadosProposta.motivoReprovacaoGeral }}
                      </p>
                    </td>
                  </tr>

                  <tr>
                    <th class="uppercase">{{ $t('Data') }} {{ $t('da') }} {{ $t('Proposta') }}</th>
                    <td>{{ ajustaDataHoraUtc(dadosProposta.createdAt) }}</td>
                  </tr>
                  <tr v-if="dadosProposta.dataVistoria">
                    <th class="uppercase">{{ $t('Data') }} {{ $t('da') }} {{ $t('Vistoria') }}</th>
                    <td>
                      {{ ajustaDataHoraUtc(dadosProposta.dataVistoria) }}
                    </td>
                  </tr>
                  <tr>
                    <th class="uppercase">{{ $t('Origem') }}</th>
                    <td>{{ dadosProposta.origem }}</td>
                  </tr>
                  <!-- <tr>
                    <th class="uppercase">Origem do Lead</th>
                    <td>{{ dadosProposta.nomeOrigemLead }}</td>
                  </tr> -->
                  <tr v-if="dadosProposta.cotaTabela">
                    <th class="uppercase">{{ $t('Cota') }} {{ $t('Tabela') }}</th>
                    <td>{{ dadosProposta.cotaTabela }}</td>
                  </tr>
                  <tr
                    v-if="
                      dadosProposta.valorCotaParticipacao ||
                      dadosProposta.valorParticipacaoMinimo
                    "
                  >
                    <th class="uppercase">
                      {{ agregado ? `${$t('Franquia')} ${$t('do')} ${$t('Caminhão')}` : $t('Franquia') }}
                    </th>
                    <td>
                      {{ dadosProposta.valorCotaParticipacao }}% ou mínimo de
                      {{ dadosProposta.valorParticipacaoMinimo | currency }}
                    </td>
                  </tr>
                  <!--tr v-if="dadosProposta.produtos.length > 0">
                  <th class="uppercase">Produtos</th>
                  <td>
                    <p v-for="item in dadosProposta.produtos"
                      :key="item.id">
                      {{ item.nomeProduto }} ( {{ item.valor | currency }}
                      <span v-if="item.isMensal == true">/mês</span>)
                      <span v-if="item.nomePagamento">- {{ item.nomePagamento
                      }}</span>
                    </p>
                  </td>
                </tr-->
                  <tr>
                    <th class="uppercase">{{ $t('Observação') }}</th>
                    <td>
                      {{ dadosProposta.observacao }}
                    </td>
                  </tr>
                  <tr>
                   <th class="uppercase">{{ $t('Observação') }}</th>
                    <td>
                      {{ somaValorTotalMes(dadosProposta.produtos) | currency }}
                    </td>
                  </tr>
                  <tr v-if="dadosProposta.valorComissaoAplicadaFinal">
                    <th class="uppercase">{{ $t('Valor') }} {{ $t('Comissão') }}</th>
                    <td>
                      {{ calcularTotalComissao() | currency }}
                    </td>
                  </tr>
                  <tr v-if="dadosProposta.valorComissaoAplicadaFinal">
                   <th class="uppercase">{{ $t('Valor Total Mensal') }}</th>
                    <td>
                      {{
                        (somaValorTotalMes(dadosProposta.produtos) +
                          calcularTotalComissao())
                          | currency
                      }}
                    </td>
                  </tr>
                  <tr>
                    <th class="uppercase">{{ $t('Valor') }} {{ $t('Entrada') }}</th>
                    <td>
                      {{ somaValorTotal(dadosProposta.produtos) | currency }}
                    </td>
                  </tr>
                  <tr v-if="dadosProposta.ipAceite">
                    <th class="uppercase">{{ $t('Ip') }}</th>
                    <td>{{ dadosProposta.ipAceite }}</td>
                  </tr>
                  <tr v-if="dadosProposta.cupom">
                    <th class="uppercase">{{ $t('Cupom') }} {{ $t('Utilizado') }}</th>
                    <td>{{ dadosProposta.cupom }}</td>
                  </tr>
                  <tr>
                    <th class="uppercase">{{ $t('Responsável') }} {{ $t('pela') }} {{ $t('Vistoria') }}</th>
                    <td>
                      {{
                        dadosProposta.nomeResponsavel
                          ? dadosProposta.nomeResponsavel
                          : 'Não definido'
                      }}
                    </td>
                  </tr>
                  <tr v-if="dadosProposta.vistoriaFeitaPeloConsultor">
                    <td
                      colspan="2"
                      class="bg-warning p-2 text-white text-center"
                    >
                      {{ $t('Vistoria') }} {{ $t('feita') }} {{ $t('pelo') }} {{ $t('Consultor') }}
                    </td>
                  </tr>
                  <tr v-if="dadosProposta.dataSincronizacaoSga">
                    <th class="uppercase">{{ $t('Data') }} {{ $t('da') }} {{ $t('Sincronização') }}</th>
                    <td>
                      {{ formataData(dadosProposta.dataSincronizacaoSga) }}
                      <vs-button
                        v-if="dadosProposta.sincronizacaoSga == false"
                        @click="resync()"
                        type="gradient"
                        icon-pack="feather"
                        icon="icon-refresh-ccw"
                        >Re-sync</vs-button
                      >
                    </td>
                  </tr>
                  <tr v-if="dadosProposta.dadosVendedor">
                    <th class="uppercase">{{ $t('Consultor') }}</th>
                    <td>{{ dadosProposta.dadosVendedor.usuario }}</td>
                  </tr>
                  <tr v-if="dadosProposta.regional">
                    <th class="uppercase">{{ $t('Regional') }}</th>
                    <td>{{ dadosProposta.regional }}</td>
                  </tr>
                  <tr v-if="dadosProposta.nomeDivisao">
                    <th class="uppercase">{{ $t('Divisão') }}</th>
                    <td>{{ dadosProposta.nomeDivisao }}</td>
                  </tr>
                  <tr v-if="formaPagamentoAtual">
                    <th class="uppercase">{{ $t('Forma') }} {{ $t('de') }} {{ $t('Pagamento') }}</th>
                    <td>{{ formaPagamentoAtual.formaPagamento }}</td>
                  </tr>
                  <tr v-if="travaFinalizarPropostaSemApolice">
                    <th class="uppercase">{{ $t('Apólice') }}</th>
                    <td v-if="dadosProposta.numeroApolice">
                      {{ dadosProposta.numeroApolice }}
                    </td>
                 <td v-else class="bg-danger text-white">
                   {{ $t('Sem') }} {{ $t('apólice') }} {{ $t('vinculada') }}
                 </td>
                  </tr>
                </table>
              </div>
              <div
                v-if="
                  dadosProposta.nomeStatus == 'Aguardando Aprovação' ||
                  (dadosProposta.nomeStatus == 'Em Aberto' &&
                    fotosGerais.length == 0) ||
                  $can('Aprovar proposta sem vistoria', 'Cotações')
                "
                slot="footer"
              >
                <vs-row vs-justify="flex-end" v-if="exibirBotoesDeAceite()">
                  <vs-button
                    v-tooltip="'Reprovar Vistoria'"
                    v-if="$can($actionsDefault.Escrita, subjectPermission)"
                    @click="cotacaoReprovar()"
                    type="gradient"
                    color="danger"
                    icon="thumb_down"
                  ></vs-button>
                  <vs-button
                    v-tooltip="'Aprovar Vistoria'"
                    v-if="$can($actionsDefault.Escrita, subjectPermission)"
                    @click="verificaAssociadoParaUnificiacao()"
                    type="gradient"
                    color="success"
                    icon="thumb_up"
                  ></vs-button>
                </vs-row>
              </div>
            </vs-card>
          </vs-col>
          <br class="break" />
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="4"
            vs-sm="4"
            vs-xs="12"
          >
            <vs-card>
              <div slot="header">
                <h3>{{ $t('Beneficiário') }}</h3>
              </div>
              <div>
                <table
                  class="table table-bordered"
                  v-if="dadosProposta.dadosCliente"
                >
                  <tr>
                    <th class="uppercase">{{ $t('Nome') }}</th>
                    <td>{{ dadosProposta.dadosCliente.associado }}</td>
                  </tr>
                  <tr>
                    <th class="uppercase">{{ $t('Email') }}</th>
                    <td>{{ dadosProposta.dadosCliente.email }}</td>
                  </tr>
                  <tr>
                    <th class="uppercase">{{ $t('Celular') }}</th>
                    <td>{{ dadosProposta.dadosCliente.celular }}</td>
                  </tr>
                  <tr v-if="dadosProposta.dadosCliente.celularAdicional">
                    <th class="uppercase">{{ $t('Celular') }} {{ $t('Adicional') }}</th>
                    <td>{{ dadosProposta.dadosCliente.celularAdicional }}</td>
                  </tr>
                  <tr>
                    <th class="uppercase">{{ $t('Fixo') }}</th>
                    <td>{{ dadosProposta.dadosCliente.telefone }}</td>
                  </tr>
                  <tr>
                    <th class="uppercase">{{ $t('Endereço') }}</th>
                    <td>
                      {{ dadosProposta.dadosCliente.cep }}
                      <br />
                      {{ dadosProposta.dadosCliente.endereco }}
                      {{ dadosProposta.dadosCliente.numero }}
                      {{ dadosProposta.dadosCliente.complemento }}
                      <br />
                      {{ dadosProposta.dadosCliente.bairro }}
                      <br />
                      {{ dadosProposta.dadosCliente.cidade }} /
                      {{ dadosProposta.dadosCliente.estado }}
                    </td>
                  </tr>
                  <tr>
                    <th class="uppercase">{{ $t('Tipo') }}</th>
                    <td>{{ dadosProposta.dadosCliente.tipo }}</td>
                  </tr>
                  <tr>
                   <th class="uppercase">
                     {{
                       dadosProposta.dadosCliente.tipo == 'Pessoa Física'
                         ? $t('CPF')
                         : $t('CNPJ')
                     }}
                   </th>
                    <td>{{ dadosProposta.dadosCliente.cpf }}</td>
                  </tr>
                  <tr>
                    <th class="uppercase">
                      {{
                        dadosProposta.dadosCliente.tipo == 'Pessoa Física'
                          ? $t('RG')
                          : $t('IE')
                      }}
                    </th>
                    <td>{{ dadosProposta.dadosCliente.rg_ie }}</td>
                  </tr>
                  <tr v-if="dadosProposta.dadosCliente.representanteLegal">
                    <th class="uppercase">{{ $t('Representante') }} {{ $t('Legal') }}</th>
                  <td>
                    {{ dadosProposta.dadosCliente.representanteLegal }} {{ $t('CPF') }}:
                    {{ dadosProposta.dadosCliente.cpfRepresentante }}
                  </td>
                  </tr>
                  <tr>
                    <th class="uppercase">{{ $t('Data') }} {{ $t('de') }} {{ $t('Nascimento') }}</th>
                    <td>{{ dadosProposta.dadosCliente.dataNascimento }}</td>
                  </tr>
                  <tr>
                    <th class="uppercase">{{ $t('CNH') }}</th>
                   <td>
                     {{ dadosProposta.dadosCliente.cnh }} ({{ dadosProposta.dadosCliente.catCnh }})
                     <br />
                     {{ $t('Vencimento') }}
                     {{ dadosProposta.dadosCliente.dataVencimentoCnh }}
                   </td>
                  </tr>
                  <tr>
                    <th class="uppercase">{{ $t('Assinatura') }}</th>
                    <td>
                      <img :src="dadosProposta.assinatura" class="assinatura" />
                    </td>
                  </tr>
                </table>
              </div>
            </vs-card>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="4"
            vs-sm="4"
            vs-xs="12"
          >
            <vs-card>
              <div slot="header">
                <h3>{{ $t('Veículo') }}</h3>
              </div>
              <div>
                <table
                  class="table table-bordered"
                  v-if="dadosProposta.dadosVeiculo"
                >
                  <tr v-if="dadosProposta.isZero">
                    <th class="uppercase">{{ $t('Zero') }} {{ $t('KM') }}</th>
                    <td class="bg-success text-white p-2">
                      {{ $t('NF') }}: {{ dadosProposta.nf }}
                      <br />
                      {{ verificaEmpresa() ? `${$t('Dt')}. ${$t('Saída')} ${$t('NF')}:` : `${$t('Data')}:` }}
                      {{ dadosProposta.dataNf }}
                      <br />
                      {{ $t('valor:') }} {{ dadosProposta.valorNf | currency }}
                    </td>
                  </tr>
                  <tr v-if="!verificarGrupo && dadosProposta.nomeGrupo">
                    <th class="uppercase">{{ $t('Grupo') }}</th>
                    <td>{{ dadosProposta.nomeGrupo }}</td>
                  </tr>
                  <tr
                    v-if="
                      verificarGrupo && dadosProposta.vistoriaFeitaPeloConsultor
                    "
                  >
                    <td
                      colspan="2"
                      class="bg-danger p-3 text-white text-center font-bold"
                    >
                      {{ $t('Por favor')}}, {{ $t('verifique')}} {{$t('o')}} {{ $t('Grupo') }} {{ $t('do') }} {{ $t('Veículo') }}
                    </td>
                  </tr>
                  <tr v-if="verificarGrupo && dadosProposta.nomeGrupo">
                    <th class="uppercase bg-danger text-white">{{ $t('Grupo') }}</th>
                    <td class="bg-danger">
                      <div class="box text-white font-black">
                        {{ dadosProposta.nomeGrupo }}
                        <vs-button
                          v-if="
                            $can($actionsDefault.Escrita, subjectPermission)
                          "
                          @click="removePedidoRevisaoGrupo(), editarProposta()"
                          icon-pack="feather"
                          icon="icon-edit-2"
                          color="warning"
                          type="gradient"
                          class="btn-print"
                          v-tooltip="'Editar Dados da Proposta'"
                        >
                        </vs-button>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="dadosProposta.nomeClassificacao">
                   <th class="uppercase">{{ $t('Classificação') }}</th>
                    <td>{{ dadosProposta.nomeClassificacao }}</td>
                  </tr>
                  <tr v-if="dadosProposta.dadosVeiculo.veiculoMarca">
                    <th class="uppercase">{{ $t('Marca') }}</th>
                    <td>{{ dadosProposta.dadosVeiculo.veiculoMarca }}</td>
                  </tr>
                  <tr v-if="dadosProposta.dadosVeiculo.veiculoModelo">
                    <th class="uppercase">{{ $t('Modelo') }}</th>
                    <td>{{ dadosProposta.dadosVeiculo.veiculoModelo }}</td>
                  </tr>
                  <tr v-if="dadosProposta.dadosVeiculo.anoFabricacao">
                    <th class="uppercase">Ano</th>
                    <td>
                      {{
                        dadosProposta.dadosVeiculo.anoFabricacao == '32000'
                          ? '0Km'
                          : `${dadosProposta.dadosVeiculo.anoFabricacao} / ${dadosProposta.dadosVeiculo.anoModelo}`
                      }}
                    </td>
                  </tr>
                  <tr v-if="dadosProposta.dadosVeiculo.placa">
                    <th class="uppercase">{{ $t('Placa') }}</th>
                    <td>{{ dadosProposta.dadosVeiculo.placa }}</td>
                  </tr>
                  <tr v-if="dadosProposta.dadosVeiculo.renavam">
                    <th class="uppercase">{{ $t('Renavam') }}</th>
                    <td>{{ dadosProposta.dadosVeiculo.renavam }}</td>
                  </tr>
                  <tr v-if="dadosProposta.dadosVeiculo.chassi">
                    <th class="uppercase">{{ $t('Chassi') }}</th>
                    <td style="text-transform: uppercase">
                      {{ dadosProposta.dadosVeiculo.chassi }}
                    </td>
                  </tr>
                  <tr v-if="dadosProposta.dadosVeiculo.combustivel">
                    <th class="uppercase">{{ $t('Combustivel') }}</th>
                    <td>{{ dadosProposta.dadosVeiculo.combustivel }}</td>
                  </tr>
                  <tr v-if="dadosProposta.dadosVeiculo.tipoCambio">
                    <th class="uppercase">{{ $t('Tipo') }} {{ $t('de') }}{{ $t('Câmbio') }}</th>
                    <td>{{ dadosProposta.dadosVeiculo.tipoCambio }}</td>
                  </tr>
                  <tr v-if="dadosProposta.dadosVeiculo.numeroMotor">
                    <th class="uppercase">{{ `${$t('Número')} ${$t('do')} ${$t('Motor')}` }}</th>
                    <td>{{ dadosProposta.dadosVeiculo.numeroMotor }}</td>
                  </tr>
                  <tr v-if="dadosProposta.dadosVeiculo.cilindradas">
                    <th class="uppercase">{{ $t('Cilindrada') }}</th>
                    <td>{{ dadosProposta.dadosVeiculo.cilindradas }}</td>
                  </tr>
                  <tr v-if="dadosProposta.dadosVeiculo.codigoFipe">
                    <th class="uppercase">{{ $t('Codigo') }} {{ $t('Fipe') }}</th>
                    <td>{{ dadosProposta.dadosVeiculo.codigoFipe }}</td>
                  </tr>
                  <tr v-if="dadosProposta.dadosVeiculo.cor">
                    <th class="uppercase">{{ $t('Cor') }}</th>
                    <td>{{ dadosProposta.dadosVeiculo.cor }}</td>
                  </tr>
                  <tr v-if="dadosProposta.dadosVeiculo.estadoPneu">
                    <th class="uppercase">{{ $t('Estado') }} {{ $t('do') }} {{ $t('Pneu') }}</th>
                    <td>{{ dadosProposta.dadosVeiculo.estadoPneu }}</td>
                  </tr>
                  <tr>
                    <th class="uppercase">{{ $t('km') }}</th>
                    <td>{{ dadosProposta.dadosVeiculo.km }}</td>
                  </tr>
                  <tr v-if="exigirCampoEstacionamentoProposta">
                   <th class="uppercase">{{ $t('Possui') }} {{ $t('garagem') }} {{ $t('para') }} {{ $t('guarda') }} {{ $t('do') }} {{ $t('veículo') }}</th>
                    <td>{{ dadosProposta.nomeTipoEstacionamento }}</td>
                  </tr>
                  <tr v-if="dadosProposta.dadosVeiculo.valorFipe">
                    <th class="uppercase">{{ $t('Valor') }}</th>
                    <td>
                      {{ dadosProposta.dadosVeiculo.valorFipe | currency }}
                    </td>
                  </tr>
                  <tr v-if="dadosProposta.dadosVeiculo.valorCobertura">
                    <th class="uppercase">{{ $t('Valor') }} {{ $t('Cobertura') }}</th>
                    <td>
                      {{ dadosProposta.dadosVeiculo.valorCobertura | currency }}
                    </td>
                  </tr>
                  <tr v-if="false">
                    <th class="uppercase">{{ $t('Táxi') }} / {{ $t('APP') }}</th>

                    <td>{{ dadosProposta.isTaxiOrApp ? $t('Sim') : $t('Não') }}</td>
                  </tr>
                  <tr v-if="dadosProposta.restricoes.length > 0">
                    <th class="uppercase">{{ $t('Restrições') }}</th>
                    <td>
                      <p
                        v-for="item in dadosProposta.restricoes"
                        :key="item.id"
                      >
                        {{ item.descricao }}
                      </p>
                    </td>
                  </tr>
                  <tr v-if="dadosProposta.acessorios.length > 0">
                    <th class="uppercase">{{ $t('Acessórios') }}</th>
                    <td>
                      <p>
                        {{
                          dadosProposta.acessorios
                            .map((el) => {
                              return ' ' + el.descricao;
                            })
                            .toString()
                        }}
                      </p>
                    </td>
                  </tr>
                  <tr v-if="dadosProposta.detalhesAcessorios">
                    <th class="uppercase">{{ $t('Defeitos') }}</th>
                    <td>{{ dadosProposta.detalhesAcessorios }}</td>
                  </tr>
                </table>
              </div>
            </vs-card>
          </vs-col>
        </vs-row>

        <vs-row v-if="dadosProposta.produtos.length > 0">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="12"
            vs-sm="12"
            vs-xs="12"
          >
            <vs-card>
              <div slot="header">
               <h3>{{ $t('Produtos') }}</h3>
              </div>
              <table class="table table-bordered">
               <tr>
                 <th>{{ $t('Nome') }} {{ $t('Produto') }}</th>
                 <th class="hidden sm:block">{{ $t('Tipo') }}</th>
                 <th class="hidden sm:block">{{ $t('Valor') }} {{ $t('Inicial') }}</th>
                 <th>{{ $t('Valor') }} {{ $t('Desconto') }}</th>
                 <th>{{ $t('Tipo') }} {{ $t('Desconto') }}</th>
                 <th>{{ $t('Valor') }} {{ $t('Final') }}</th>
                 <th class="hidden sm:block">{{ $t('Forma') }} {{ $t('de') }} {{ $t('Pagamento') }}</th>
               </tr>
                <tr
                  v-for="item in dadosProposta.produtos"
                  :key="item.idProduto"
                >
                  <td>{{ item.nomeProduto }}</td>
                <td class="hidden sm:block">
                  {{ item.obrigatorio ? $t('Obrigatório') : $t('Opcional') }} -
                  {{ item.isMensal ? $t('Mensal') : $t('Entrada') }}
                </td>
                  <td class="hidden sm:block">
                    <span
                      v-if="item.valor != item.valorFinal"
                      style="text-decoration: line-through"
                      >{{ item.valor | currency }}</span
                    >
                    <span v-else>{{ item.valor | currency }}</span>
                  </td>
                  <td>{{ (item.valor - item.valorFinal) | currency }}</td>
                  <td>
                    {{
                      item.valor - item.valorFinal > 0
                        ? item.tipoDesconto
                        : null
                    }}
                  </td>
                  <td>
                    <b>{{ item.valorFinal | currency }}</b>
                  </td>
                  <!-- <td>
                    {{ item. }}
                  </td> -->
                  <td class="hidden sm:block">{{ item.nomePagamento }}</td>
                </tr>
              </table>
            </vs-card>
          </vs-col>
        </vs-row>
        <!-- Implementos -->
        <vs-row v-if="implemento">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="12"
            vs-sm="12"
            vs-xs="12"
          >
            <vs-card>
              <div slot="header">
                <h3>{{ $t('Implementos') }}</h3>
              </div>
              <vs-collapse type="border">
                <vs-collapse-item
                  v-for="item in implementos"
                  :key="item.idPropostaComplemento"
                >
                  <div slot="header">
                    <b
                      >{{ item.descricao ? `${item.descricao}` : '' }}
                      {{ item.marca }} {{ item.modelo }}</b
                    >
                  </div>
                  <vs-card>
                    <table class="table table-bordered">
                      <tr v-if="item.placa">
                        <th class="uppercase">{{ $t('Placa') }} {{ $t('do') }} {{ $t('Implemento') }}</th>
                        <td>{{ item.placa }}</td>
                      </tr>
                      <!-- <tr v-if="item.placaVeiculoTrator ">
                        <th class="uppercase">Placa do Veículo Trator</th>
                        <td>{{ item.placaVeiculoTrator }}</td>
                      </tr>
                      <tr v-if="item.chassiVeiculoTrator">
                        <th class="uppercase">Chassi do Veículo Trator</th>
                        <td>{{ item.chassiVeiculoTrator }}</td>
                      </tr> -->
                      <!-- <tr v-if="item.classificacaoImplemento">
                        <th class="uppercase">Classificação do Implemento</th>
                        <td>{{ item.classificacaoImplemento }}</td>
                      </tr> -->
                    <tr v-if="item.tipo">
                      <th class="uppercase">{{ $t('Tipo') }} {{ $t('de') }} {{ $t('Implemento') }}</th>
                      <td>{{ item.tipo }}</td>
                    </tr>
                    <tr v-if="item.marca">
                      <th class="uppercase">{{ $t('Marca') }} {{ $t('do') }} {{ $t('Implemento') }}</th>
                      <td>{{ item.marca }}</td>
                    </tr>
                    <tr v-if="item.modelo">
                      <th class="uppercase">{{ $t('Modelo') }} {{ $t('do') }} {{ $t('Implemento') }}</th>
                      <td>{{ item.modelo }}</td>
                    </tr>
                      <!-- <tr v-if="item.estrura">
                        <th class="uppercase">Tipo de estrutura</th>
                        <td>{{ item.estrura }}</td>
                      </tr> -->
                    <tr v-if="item.valorCobertura">
                      <th class="uppercase">{{ $t('Valor') }} {{ $t('Cobertura') }}</th>
                      <td>R$ {{ item.valorCobertura }}</td>
                    </tr>
                      <!-- <tr v-if="item.anoFabricacao">
                        <th class="uppercase">Ano de Fabricação</th>
                        <td>{{ item.anoFabricacao }}</td>
                      </tr>
                      <tr v-if="item.corPredominante">
                        <th class="uppercase">Cor predominante</th>
                        <td>{{ item.corPredominante }}</td>
                      </tr>
                      <tr v-if="item.quantidadeEixo">
                        <th class="uppercase">Quantidade de Eixo</th>
                        <td>{{ item.quantidadeEixo }}</td>
                      </tr>
                      <tr v-if="item.quantidadePneus">
                        <th class="uppercase">Quantidade de Pneus</th>
                        <td>{{ item.quantidadePneus }}</td>
                      </tr>
                      <tr v-if="item.comprimento">
                        <th class="uppercase">Comprimento</th>
                        <td>{{ item.comprimento }}</td>
                      </tr>
                      <tr v-if="item.altura">
                        <th class="uppercase">Altura</th>
                        <td>{{ item.altura }}</td>
                      </tr>
                      <tr v-if="item.largura">
                        <th class="uppercase">Largura</th>
                        <td>{{ item.largura }}</td>
                      </tr>
                      <tr v-if="item.PTBC">
                        <th class="uppercase">Peso Bruto Combinado (Ton.)</th>
                        <td>{{ item.PTBC }}</td>
                      </tr>
                      <tr v-if="item.capacidadeCargaTon">
                        <th class="uppercase">Capac. de Carga em Ton.</th>
                        <td>{{ item.capacidadeCargaTon }}</td>
                      </tr> -->
                      <tr v-if="item.observacao">
                        <th class="uppercase">{{ $t('Observações') }}</th>
                        <td>{{ item.observacao }}</td>
                      </tr>
                    </table>
                  </vs-card>
                </vs-collapse-item>
              </vs-collapse>
            </vs-card>
          </vs-col>
        </vs-row>

        <!-- Agregados -->
        <vs-row v-if="agregado && !dadosProposta.unificarAgregados">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="12"
            vs-sm="12"
            vs-xs="12"
          >
            <vs-card>
              <div slot="header">
                <h3>{{ $t('Agregados') }}</h3>
              </div>
              <vs-collapse type="border">
                <vs-collapse-item
                  v-for="item in agregados"
                  :key="item.idPropostaComplemento"
                >
                  <div slot="header">
                    <b
                      >{{ item.placa ? `${item.placa} ` : '' }}
                      {{
                        item.chassi && !item.placa ? `${item.chassi} | ` : ''
                      }}</b
                    >
                    {{ item.marca }} {{ item.modelo }}
                  </div>
                  <vs-row>
                    <vs-card>
                      <table class="table table-bordered">
                        <tr v-if="item.descricaoAgregado">
                          <th class="uppercase">{{ $t('Descrição') }} {{ $t('do') }} {{ $t('agregado') }}</th>
                          <td>{{ item.descricao }}</td>
                        </tr>
                        <tr v-if="item.placa">
                          <th class="uppercase">{{ $t('Placa') }}</th>
                          <td>{{ item.placa }}</td>
                        </tr>
                        <tr v-if="item.chassi">
                          <th class="uppercase">{{ $t('Chassi') }}</th>
                          <td>{{ item.chassi }}</td>
                        </tr>
                        <tr v-if="item.marca">
                          <th class="uppercase">{{ $t('Marca') }}</th>
                          <td>{{ item.marca }}</td>
                        </tr>
                        <tr v-if="item.modelo">
                          <th class="uppercase">{{ $t('Modelo') }}</th>
                          <td>{{ item.modelo }}</td>
                        </tr>
                        <tr v-if="item.valorCobertura">
                          <th class="uppercase">{{ $t('Valor') }} {{ $t('Cobertura') }}</th>
                          <td>{{ item.valorCobertura }}</td>
                        </tr>
                        <tr v-if="item.porcentagemParticipacao || item.valorMinimoParticipacao">
                          <th class="uppercase">{{ $t('Franquia') }}:</th>
                          <td>
                            {{ item.porcentagemParticipacao }}% {{ $t('ou') }} {{ $t('mínimo') }} {{ $t('de') }}
                            {{ item.valorMinimoParticipacao | currency }}
                          </td>
                        </tr>
                        <tr v-if="item.observacao">
                          <th class="uppercase">{{ $t('Observações') }}</th>
                          <td>{{ item.observacao }}</td>
                        </tr>
                      </table>
                    </vs-card>
                  </vs-row>

                  <vs-row class="mt-5">
                    <vs-card>
                      <div slot="header">
                        <h3>{{ $t('Produtos') }}</h3>
                      </div>
                      <table class="table table-bordered">
                        <tr>
                          <th>{{ $t('Nome') }} {{ $t('Produto') }}</th>
                          <th>{{ $t('Tipo') }}</th>
                          <th>{{ $t('Valor') }} {{ $t('Inicial') }}</th>
                          <th>{{ $t('Valor') }} {{ $t('Desconto') }}</th>
                          <th>{{ $t('Valor') }} {{ $t('Final') }}</th>
                          <th>{{ $t('Forma') }} {{ $t('de') }} {{ $t('Pagamento') }}</th>
                        </tr>
                        <tr
                          v-for="prodAgregado in filtraProdutosSelecionadosAgregado(
                            item.idPropostaComplemento,
                          )"
                          :key="prodAgregado.idProduto"
                        >
                          <td>{{ prodAgregado.nomeProduto }}</td>
                        <td>
                          {{
                            prodAgregado.obrigatorio
                              ? $t('Obrigatório')
                              : $t('Opcional')
                          }}
                          - {{ prodAgregado.isMensal ? $t('Mensal') : $t('À vista') }}
                        </td>
                          <td>
                            <span
                              v-if="prodAgregado.descontoConcedido > 0"
                              style="text-decoration: line-through"
                              >{{ prodAgregado.valor | currency }}</span
                            >
                            <span v-else>{{
                              prodAgregado.valor | currency
                            }}</span>
                          </td>
                          <td>{{ prodAgregado.descontoConcedido }} %</td>
                          <td>
                            <b>{{ prodAgregado.valorFinal | currency }}</b>
                          </td>
                          <td>{{ prodAgregado.nomePagamento }}</td>
                        </tr>
                      </table>
                    </vs-card>
                  </vs-row>
                </vs-collapse-item>
              </vs-collapse>
            </vs-card>
          </vs-col>
        </vs-row>

        <!-- Agregados unificados -->
        <vs-row v-if="agregado && dadosProposta.unificarAgregados">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="12"
            vs-sm="12"
            vs-xs="12"
          >
            <vs-card>
              <div slot="header">
                <h3>{{ $t('Agregados') }}</h3>
              </div>
              <vs-collapse type="border">
                <vs-collapse-item
                  v-for="item in agregados"
                  :key="item.idPropostaComplemento"
                >
                  <div slot="header">
                    <b
                      >{{ item.placa ? `${item.placa} ` : '' }}
                      {{
                        item.chassi && !item.placa ? `${item.chassi} | ` : ''
                      }}</b
                    >
                    {{ item.marca }} {{ item.modelo }}
                  </div>
                  <vs-row>
                    <vs-card>
                      <table class="table table-bordered">
                        <tr v-if="item.descricaoAgregado">
                          <th class="uppercase">{{ $t('Descrição') }} {{ $t('do') }} {{ $t('agregado') }}</th>
                          <td>{{ item.descricao }}</td>
                        </tr>
                        <tr v-if="item.placa">
                          <th class="uppercase">{{ $t('Placa') }}</th>
                          <td>{{ item.placa }}</td>
                        </tr>
                        <tr v-if="item.chassi">
                          <th class="uppercase">{{ $t('Chassi') }}</th>
                          <td>{{ item.chassi }}</td>
                        </tr>
                        <tr v-if="item.marca">
                          <th class="uppercase">{{ $t('Marca') }}</th>
                          <td>{{ item.marca }}</td>
                        </tr>
                        <tr v-if="item.modelo">
                          <th class="uppercase">{{ $t('Modelo') }}</th>
                          <td>{{ item.modelo }}</td>
                        </tr>
                        <tr v-if="item.valorCobertura">
                          <th class="uppercase">{{ $t('Valor') }} {{ $t('Cobertura') }}</th>
                          <td>{{ item.valorCobertura }}</td>
                        </tr>
                        <tr v-if="item.porcentagemParticipacao || item.valorMinimoParticipacao">
                          <th class="uppercase">{{ $t('Franquia') }}:</th>
                          <td>
                            {{ item.porcentagemParticipacao }}% {{ $t('ou') }} {{ $t('mínimo') }} {{ $t('de') }}
                            {{ item.valorMinimoParticipacao | currency }}
                          </td>
                        </tr>
                        <tr v-if="item.observacao">
                          <th class="uppercase">{{ $t('Observações') }}</th>
                          <td>{{ item.observacao }}</td>
                        </tr>
                      </table>
                    </vs-card>
                  </vs-row>
                </vs-collapse-item>
              </vs-collapse>
            </vs-card>
          </vs-col>
          <vs-row class="mt-5">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="12"
              vs-sm="12"
              vs-xs="12"
            >
              <vs-card>
                <div slot="header">
                  <h3>{{ $t('Produtos') }} {{ $t('Agregados') }}</h3>
                </div>
                <table class="table table-bordered">
                  <tr>
                    <th>{{ $t('Nome') }} {{ $t('Produto') }}</th>
                    <th>{{ $t('Tipo') }}</th>
                    <th>{{ $t('Valor') }} {{ $t('Inicial') }}</th>
                    <th>{{ $t('Valor') }} {{ $t('Desconto') }}</th>
                    <th>{{ $t('Valor') }} {{ $t('Final') }}</th>
                    <th>{{ $t('Forma') }} {{ $t('de') }} {{ $t('Pagamento') }}</th>
                  </tr>
                  <tr
                    v-for="prodAgregado in dadosProposta.produtosAgregadoUnificados"
                    :key="prodAgregado.idProduto"
                  >
                    <td>{{ prodAgregado.nomeProduto }}</td>
                    <td>
                      {{
                        prodAgregado.obrigatorio ? 'Obrigatório' : 'Opcional'
                      }}
                      - {{ prodAgregado.isMensal ? 'Mensal' : 'À vista' }}
                    </td>
                    <td>
                      <span
                        v-if="prodAgregado.descontoConcedido > 0"
                        style="text-decoration: line-through"
                        >{{ prodAgregado.valor | currency }}</span
                      >
                      <span v-else>{{ prodAgregado.valor | currency }}</span>
                    </td>
                    <td>
                      {{ prodAgregado.descontoConcedido | currency }}
                    </td>
                    <td>
                      <b>{{ prodAgregado.valorFinal | currency }}</b>
                    </td>
                    <td>{{ prodAgregado.nomePagamento }}</td>
                  </tr>
                </table>
              </vs-card>
            </vs-col>
          </vs-row>
        </vs-row>

        <vs-row v-if="dadosFinanceiros.length > 0">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="12"
            vs-sm="12"
            vs-xs="12"
          >
            <vs-card>
              <div slot="header">
                <h3>{{ $t('Dados') }} {{ $t('Financeiros') }}</h3>
              </div>
              <vs-collapse type="border">
                <vs-collapse-item
                  v-for="item in dadosFinanceiros"
                  :key="item.id"
                >
                  <div slot="header">
                    {{ $t('Cobrança') }} {{ $t('número') }}:{{ item.id_registroFinanceiro }} -
                    {{ item.formaPagamento }}
                    <vs-chip
                      class="mr-4"
                      :color="getStatusBoletoColor(item.nomeStatus)"
                      >{{ item.nomeStatus }}</vs-chip
                    >
                    <vs-chip
                      v-if="validaVencido(item)"
                      class="mr-4"
                      color="danger"
                      >{{ $t('Vencido') }}</vs-chip
                    >
                  </div>
                  <vs-row>
                    <vs-col
                      vs-type="flex"
                      vs-justify="center"
                      vs-w="12"
                      vs-sm="12"
                      vs-xs="12"
                    >
                      <table class="table table-bordered">
                        <tr v-if="item.nossoNumero">
                         <th class="uppercase">{{ $t('Nosso') }} {{ $t('Número') }}</th>
                          <td>{{ item.nossoNumero }}</td>
                        </tr>
                        <tr>
                          <th class="uppercase">{{ $t('Data') }} {{ $t('de') }} {{ $t('Emissão') }}</th>
                          <td>
                            {{ formataDataUTCAux(item.createdAt) }}
                          </td>
                        </tr>
                        <tr>
                          <th class="uppercase">{{ $t('Data') }} {{ $t('de') }} {{ $t('Vencimento') }}</th>
                          <td>
                            {{ formataDataUTCAux(item.dataVencimento) }}
                          </td>
                        </tr>
                        <tr v-if="item.dataPagamento">
                          <th class="uppercase">{{ $t('Data') }} {{ $t('de') }} {{ $t('Pagamento') }}</th>
                          <td>
                            {{ formataDataUTCAux(item.dataPagamento) }}
                          </td>
                        </tr>
                        <tr>
                          <th class="uppercase">{{ $t('Valor') }}</th>
                          <td>{{ item.valor | currency }}</td>
                        </tr>
                        <tr v-if="item.linhaDigitavel">
                          <th class="uppercase">{{ $t('Linha') }} {{ $t('Digitavel') }}</th>
                          <td>{{ item.linhaDigitavel }}</td>
                        </tr>
                        <tr v-if="item.linkBoleto">
                         <th class="uppercase">{{ $t('Link') }} {{ $t('Boleto') }}</th>
                          <td v-html="formataLink(item.linkBoleto)"></td>
                        </tr>
                        <tr v-if="item.pixImage">
                          <th class="uppercase">{{ $t('Pix') }} {{ $t('Qr') }} {{ $t('Imagem') }}</th>
                          <td><img :src="item.pixImage" /></td>
                        </tr>
                        <tr v-if="item.pixQrCode">
                          <th class="uppercase">{{ $t('Pix') }} {{ $t('Qr') }} {{ $t('Code') }}</th>
                          <td>{{ item.pixQrCode }}</td>
                        </tr>
                      </table>
                    </vs-col>
                  </vs-row>
                </vs-collapse-item>
              </vs-collapse>
            </vs-card>
          </vs-col>
        </vs-row>
        <br class="break" />
        <div v-if="fotosGerais.length >= 1" class="mt-2 text-right mb-4">
          <vs-button
            color="primary"
            type="border"
            class="mr-3"
            v-if="
              (this.dadosProposta.idStatus == 7 ||
                this.dadosProposta.idStatus == 5) &&
              $can('Aceitar Pré Análise', 'Vistorias') &&
              filtraFotos().length > 0
            "
            @click="liberarAguardandoAprovacao"
          >
       <vs-icon icon="check" class="mr-3"></vs-icon>{{ $t('Liberar') }} {{ $t('para') }} "{{ $t('Aguardando') }}
            {{ $t('Aprovação') }}"
          </vs-button>

          <vs-button
            color="success"
            type="border"
            class="mr-3"
            v-if="
              responsavelVistoria &&
              $can($actionsDefault.Escrita, subjectPermission) &&
              filtraFotos().length > 0 &&
              dadosProposta.idStatus != 4
            "
            @click="
              promptAprovarReprovar = true;
              isAprovarTodas = true;
            "
          >
            <vs-icon icon="thumb_up" class="mr-3"></vs-icon>{{ $t('Aprovar') }} {{ $t('Todas') }}
          </vs-button>

          <vs-button
            color="danger"
            type="border"
            class="mr-3"
            v-if="
              responsavelVistoria &&
              $can($actionsDefault.Escrita, subjectPermission) &&
              filtraFotos().length > 0 &&
              dadosProposta.idStatus != 4
            "
            @click="
              promptAprovarReprovar = true;
              isAprovarTodas = false;
            "
          >
            <vs-icon icon="thumb_down" class="mr-3"></vs-icon>{{ $t('Reprovar') }} {{ $t('Todas') }}
          </vs-button>

          <vs-button
            color="warning"
            type="border"
            class="mr-3"
            @click="modalUpload = true"
            v-if="verificaPermissaoUpload()"
          >
            <vs-icon icon-pack="feather" icon="icon-upload"></vs-icon>{{ $t('Upload') }} {{ $t('Manual') }}
          </vs-button>

          <vs-button
            color="warning"
            type="border"
            class="mr-3"
            @click="modalUpload = true"
            v-if="
              (($can('Upload', subjectPermission) &&
                dadosProposta.idStatus != 3) ||
                ($can(
                  'Acesso ao Upload Manual no status Aguardando Aprovação',
                  subjectPermission,
                ) &&
                  $can('Upload', subjectPermission) &&
                  dadosProposta.idStatus == 3)) &&
              !verificaEmpresa()
            "
          >
           <vs-icon icon-pack="feather" icon="icon-upload"></vs-icon>{{ $t('Upload') }} {{ $t('Manual') }}
          </vs-button>
        </div>
        <vs-row>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="12"
          >
            <vs-card class="w-full">
              <div slot="header">
                <h3>
                  {{ $t('Fotos') }}
                  <vs-select
                    class="float-right filtroFotos"
                    label="Filtro Por:"
                    v-model="filtroFoto"
                  >
                    <vs-select-item
                      :key="item"
                      :value="item"
                      :text="item"
                      v-for="item in tiposFotos"
                    />
                  </vs-select>

                  <br style="clear: both" />
                </h3>
              </div>
              <div>
                <div
                  v-if="filtraFotos().length == 0"
                  class="flex justify-center"
                >
                  <h4>Não há itens a serem exibidos para esse filtro.</h4>
                </div>
                <vs-row
                  v-if="filtraFotos().length > 0"
                  class="mt-5"
                  vs-justify="center"
                >
                  <vs-col
                    v-for="item in filtraFotos()"
                    :key="item.id"
                    type="flex"
                    vs-justify="center"
                    vs-align="center"
                    class="mb-4 w-full sm:w-1/2 lg:w-1/3 xl:w-1/4"
                  >
                    <vs-card :class="verificaBg(item)">
                      <div slot="header" class="flex justify-between">
                        <h3 class="w-2/3">
                          {{ item.nomePosicao }}
                        </h3>
                        <div
                          class="w-1/3 sm:w-auto lg:w-1/3 flex gap-1 justify-end"
                        >
                          <vs-button
                            v-tooltip="'Visualizar Padrão'"
                            @click="openModalFoto('Padrão', item)"
                            class="float-right"
                            type="gradient"
                            color="dark"
                            icon="info"
                          ></vs-button>
                          <vs-button
                            v-tooltip="'Deletar Imagem'"
                            @click="openPromptDelete(item)"
                            class="float-right mr-1"
                            type="gradient"
                            color="danger"
                            icon-pack="feather"
                            icon="icon-trash-2"
                            v-if="
                              $can(deleteImgsPermission, subjectPermission) &&
                              responsavelVistoria &&
                              !item.aprovada
                            "
                          ></vs-button>
                        </div>
                        <div
                          v-if="$can('Editar Tipo Foto Adicional', 'Vistorias')"
                        >
                          <vs-select
                            v-if="item.id_modeloFoto == 999"
                            class="p-3 w-full"
                            label="Alterar tipo da foto:"
                            v-model="item.tipoAlterado"
                            @input="atualizaTipoFoto(item)"
                          >
                            <vs-select-item
                              :key="itemTipoFoto.id_modelofoto"
                              :value="itemTipoFoto"
                              :text="itemTipoFoto.nomePosicao"
                              v-for="itemTipoFoto in fotosGerais"
                            />
                          </vs-select>
                        </div>
                      </div>
                      <div>
                        <div
                          v-if="item.endereco"
                          class="m-2 mb-4"
                          style="clear: both"
                        >
                          <vs-button
                            v-tooltip="'Visualizar Mapa'"
                            v-if="item.latitude"
                            @click="openModalMap(item)"
                            class="float-left mr-2"
                            type="gradient"
                            color="primary"
                            icon-pack="feather"
                            icon="icon-map-pin"
                          ></vs-button>
                          <span
                            v-if="item.nome"
                            :class="`${
                              item.aprovada == null ? '' : 'text-white'
                            }`"
                          >
                            <span v-if="validTypeOfEndereco(item.endereco)">{{
                              item.endereco
                            }}</span>
                            <span v-else
                              >{{ item.endereco.road }} -
                              {{ item.endereco.neighbourhood }}
                              {{ item.endereco.city }} /
                              {{ item.endereco.state }}</span
                            >
                          <p v-if="item.dataFoto">
                            {{ `${$t('Sincronizada')} ${$t('em:')}` }}
                            {{
                              verificaSefotoFoiAtualizada(
                                item.dataFoto,
                                item.dataAtualizacao,
                              )
                            }}
                          </p>
                           <p v-if="item.dataFotoCaptura">
                             {{ `${$t('Capturada')} ${$t('em:')}` }}
                             {{ formataData(item.dataFotoCaptura) }}
                           </p>
                          </span>
                        </div>
                        <div
                          v-if="item.userUploadedName"
                          class="m-2 mb-4"
                          style="clear: both"
                          :class="`${
                            item.aprovada == null ? '' : 'text-white'
                          }`"
                        >
                          Upload por: {{ item.userUploadedName }}
                        </div>

                        <video
                          class="video"
                          style="max-height: 130px; margin: auto; display: flex"
                          v-if="verificaExtensaoVideo(item.nome)"
                          controls
                          muted
                          loop
                          :src="item.nome"
                        ></video>

                        <img
                          @click="openModalFoto('Foto', item)"
                          v-if="verificaExtensaoImagem(item.nome)"
                          :src="item.nome"
                          class="foto"
                          width="100%"
                        />

                        <div
                          v-else-if="!verificaExtensaoVideo(item.nome)"
                          class="flex flex-col items-center"
                        >
                          <img
                            class="foto"
                            width="80%"
                            src="../../../src/assets/images/elements/PDF_file_icon2.png"
                          />
                          <a :href="item.nome" target="_blank">{{
                            formataUrlLink(item.nome)
                          }}</a>
                        </div>

                        <div v-if="item.observacaoVistoria">
                        <span
                          :class="`${
                            item.aprovada == null ? '' : 'text-white'
                          }`"
                        >
                          <b>{{ $t('Observação:') }}</b>
                        </span>
                          >
                          <p
                            :class="`${
                              item.aprovada == null
                                ? 'break-words'
                                : 'text-white break-words'
                            }`"
                          >
                            {{ item.observacaoVistoria }}
                          </p>
                        </div>

                        <h5
                          v-if="item.aprovada == false"
                          class="text-center text-white p-4 mb-3"
                        >
                          {{ item.motivoReprovacao }}
                        </h5>
                      </div>
                      <div
                        slot="footer"
                        v-if="responsavelVistoria && item.aprovada == null"
                      >
                        <vs-row class="flex justify-end gap-1">
                          <vs-button
                            v-tooltip="'Recusar Foto'"
                            @click="openPrompt(item)"
                            type="gradient"
                            color="danger"
                            icon="thumb_down"
                            v-if="
                              $can($actionsDefault.Escrita, subjectPermission)
                            "
                          ></vs-button>
                          <vs-button
                            v-tooltip="'Aprovar Foto'"
                            @click="aprovarFoto(item)"
                            v-if="
                              $can($actionsDefault.Escrita, subjectPermission)
                            "
                            type="gradient"
                            color="success"
                            icon="thumb_up"
                          ></vs-button>
                        </vs-row>
                      </div>
                    </vs-card>
                  </vs-col>
                </vs-row>
              </div>
              <br class="break" />
              <vs-button
                v-if="
                  $can(deleteImgsPermission, subjectPermission) &&
                  imgsDeletadas &&
                  imgsDeletadas.length > 0
                "
                @click.stop.prevent="showDeletedImgs"
                type="gradient"
                class="float-right mb-2"
                color="danger"
              >{{ `${$t('Fotos')} ${$t('Deletadas')}` }}</vs-button
              >
            </vs-card>
          </vs-col>
        </vs-row>


        <!-- Mensagens -->
        <vs-row>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="12"
          >
            <FormMensagemVistoria :idEmpresa="dadosProposta.idEmpresa" />
          </vs-col>
        </vs-row>
      </div>

      <vs-popup
        class="holamundo"
        :title="'Local da Foto'"
        :active.sync="openModalMapa"
        @close="itemMapaModal = null"
      >
        <iframe
          v-if="itemMapaModal"
          width="100%"
          height="170"
          frameborder="0"
          scrolling="no"
          marginheight="0"
          marginwidth="0"
          :src="`https://maps.google.com/maps?q=${itemMapaModal.latitude},${itemMapaModal.longitude}&hl=pt-br&z=15&amp;output=embed`"
        ></iframe>
      </vs-popup>

      <vs-popup
       :title="
         isAprovarTodas ? `${$t('Aprovar')} ${$t('todas')} ${$t('as')} ${$t('Fotos')}` : `${$t('Reprovar')} ${$t('todas')} ${$t('as')} ${$t('Fotos')}`
       "
        @cancel="isAprovarTodas = null"
        @close="promptAprovarReprovar = false"
        :active.sync="promptAprovarReprovar"
      >
       <vs-alert
         style="height: auto"
         :title="$t('Atenção')"
         active="true"
         color="danger"
       >
         {{ $t('Ao') }} {{ $t('Clicar') }} {{ $t('no') }} {{ $t('botão') }} {{ $t('abaixo,') }} {{ $t('todas') }} {{ $t('as') }} {{ $t('fotos') }} {{ $t('sem') }} {{ $t('aprovação/reprovação') }} {{ $t('serão') }} {{ $t('impactadas') }}
       </vs-alert>
        <vs-button
          @click="aprovaReprovaTodas()"
          :color="isAprovarTodas ? 'success' : 'danger'"
          :icon="isAprovarTodas ? 'thumb_up' : 'thumb_down'"
          class="mb-2 my-5 btn-block"
        >
      <span>{{
        isAprovarTodas
          ? `${$t('Aprovar')} ${$t('todas')} ${$t('as')} ${$t('Fotos')}`
          : `${$t('Reprovar')} ${$t('todas')} ${$t('as')} ${$t('Fotos')}`
      }}</span>
        </vs-button>
      </vs-popup>

      <vs-popup
        :fullscreen="isFullscreen"
        v-if="imgModal"
        class="holamundo"
        :title="'Foto'"
        :active.sync="openModal"
        @close="closePop"
      >
        <!-- <form role="form"> -->
        <vs-row
          vs-align="flex-end"
          vs-type="flex"
          vs-justify="center"
          vs-w="12"
        >
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="12"
            class="sm:p-2 p-4 flex-col"
          >
            <h4>{{ itemModalIndex + 1 }} - {{ itemModal.nomePosicao }}</h4>
          </vs-col>
        </vs-row>
        <vs-row
          vs-align="flex-end"
          vs-type="flex"
          vs-justify="center"
          vs-w="12"
        >
          <!-- <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="3"
          class="sm:p-2 p-4 flex-col"
        >
          <span class="z-40 bg-white px-3 rounded">Zoom</span>
          <vs-switch color="success" v-model="zoomFotoSwitch" class="z-40">
            <span slot="on">Sim</span>
            <span slot="off">Não</span>
          </vs-switch>
        </vs-col> -->
          <vs-col
            v-if="tipoModal == 'Foto'"
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="2"
            class="sm:p-2 p-4 gap-x-1 z-40"
          >
            <vs-button
              icon-pack="feather"
              icon="icon-arrow-left"
              :color="'warning'"
              class="z-40"
              @click="mudaFoto('anterior')"
            />
          </vs-col>
          <vs-col
            v-if="tipoModal == 'Foto'"
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="3"
            class="sm:p-2 p-4 gap-x-1 z-40"
          >
            <vs-button
              icon-pack="feather"
              icon="icon-rotate-ccw"
              :color="'primary'"
              class="z-40"
              @click="rotateLeft"
            />
            <div class="z-40 bg-white px-3 rounded flex flex-col items-center">
              <span>{{ $t('Zoom') }}</span>
              <vs-switch color="success" v-model="zoomFotoSwitch">
                <span slot="on">{{ $t('Sim') }}</span>
                <span slot="off">{{ $t('Não') }}</span>
              </vs-switch>
            </div>
            <vs-button
              icon-pack="feather"
              icon="icon-rotate-cw"
              :color="'primary'"
              class="z-40"
              @click="rotateRight"
            />
          </vs-col>
          <vs-col
            v-if="tipoModal == 'Foto'"
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="2"
            class="sm:p-2 p-4 gap-x-1 z-40"
          >
            <vs-button
              icon-pack="feather"
              icon="icon-arrow-right"
              :color="'warning'"
              class="z-40"
              @click="mudaFoto('próximo')"
            />
          </vs-col>
        </vs-row>
        <vs-row class="flex justify-center text-red-600">
          <p class="text-red-600">
           {{
             this.dadosProposta.idStatus == 4
               ? `${$t('Não')} ${$t('é')} ${$t('possível')} ${$t('editar')} ${$t('os')} ${$t('dados')} ${$t('de')} ${$t('uma')} ${$t('proposta')} ${$t('finalizada')}.`
               : null
           }}
          </p></vs-row
        >
        <vs-row vs-type="flex" class="w-full">
          <vs-col
            v-if="itemModal.nomePosicao == 'CNH' && tipoModal == 'Foto'"
            vs-justify="center"
            vs-w="2"
            vs-align="center"
            class="mt-4"
          >
            <div class="mt-8">
              <div>
            <p><b>{{ $t('NOME') }}:</b></p>
                <vs-input
                  size="medium"
                  class="w-full"
                  name="Nome"
                  id="nome"
                  v-model="form.dadosClientePessoal.associado"
                  v-validate="{ required: true }"
                  :state="validateState('Nome')"
                  :danger="validateClass('Nome')"
                  val-icon-danger="clear"
                  danger-text="Preencha este Campo"
                  :disabled="disableSwitch"
                />
              </div>
              <div
                v-if="this.dadosProposta.dadosCliente.tipo == 'Pessoa Física'"
              >
                <div class="mt-1">
                 <p><b>{{ $t('RG') }}:</b></p>
                  <vs-input
                    size="medium"
                    class="w-full"
                    name="RG"
                    id="RG"
                    v-model="form.dadosClientePessoal.rg_ie"
                    v-validate="{ required: true }"
                    :state="validateState('RG')"
                    :danger="validateClass('RG')"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                    :disabled="disableSwitch"
                  />
                </div>
                <div class="mt-1">
                  <p><b>{{ $t('CPF') }}:</b></p>
                  <vs-input
                    size="medium"
                    class="w-full"
                    name="CPF"
                    id="CPF"
                    v-model="form.dadosClientePessoal.cpfCnpj"
                    v-mask="'###.###.###-##'"
                    v-validate="{ required: true }"
                    :state="validateState('CPF')"
                    :danger="validateClass('CPF')"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                    :disabled="disableSwitch"
                  />
                </div>
                <div class="mt-1">
                  <p><b>{{ $t('DATA') }} {{ $t('DE') }} {{ $t('NASCIMENTO') }}:</b></p>
                  <vs-input
                    size="medium"
                    class="w-full"
                    name="Data de Nascimento"
                    id="dataNascimento"
                    v-model="form.dadosClientePessoal.dataNascimento"
                    v-validate="{ required: true, date_format: 'dd/mm/yyyy' }"
                    :state="validateState('Data de Nascimento')"
                    :danger="validateClass('Data de Nascimento')"
                    val-icon-danger="clear"
                    danger-text="Preencha com uma data válida usando o formato DD/MM/AAAA"
                    :disabled="disableSwitch"
                  />
                </div>
              </div>
              <div
                v-if="this.dadosProposta.dadosCliente.tipo == 'Pessoa Jurídica'"
              >
                <div class="mt-1">
                  <p><b>{{ $t('INSCRIÇÃO') }} {{ $t('ESTADUA') }}:</b></p>
                  <vs-input
                    size="medium"
                    class="w-full"
                    name="IE"
                    id="IE"
                    v-model="form.dadosClientePessoal.rg_ie"
                    v-validate="{ required: true }"
                    :state="validateState('IE')"
                    :danger="validateClass('IE')"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                    :disabled="disableSwitch"
                  />
                </div>
                <div class="mt-1">
                  <p><b>CNPJ:</b></p>
                  <vs-input
                    size="medium"
                    class="w-full"
                    name="CNPJ"
                    id="CNPJ"
                    v-model="form.dadosClientePessoal.cpfCnpj"
                    v-mask="'##.###.###/####-##'"
                    v-validate="{ required: true }"
                    :state="validateState('CNPJ')"
                    :danger="validateClass('CNPJ')"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                    :disabled="disableSwitch"
                  />
                </div>
                <div class="mt-1">
                  <p><b>{{ $t('CPF') }} {{ $t('DO') }} {{ $t('REP.') }} {{ $t('LEGAL') }}:</b></p>
                  <vs-input
                    size="medium"
                    class="w-full"
                    name="CPF Representante"
                    id="cpfRepresentante"
                    v-model="form.dadosClientePessoal.cpfRepresentante"
                    v-mask="'###.###.###-##'"
                    v-validate="{ required: true }"
                    :state="validateState('CPF Representante')"
                    :danger="validateClass('CPF Representante')"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                    :disabled="disableSwitch"
                  />
                </div>
                <div class="mt-1">
                  <p><b>{{ $t('NOME') }} {{ $t('DO') }} {{ $t('REP.') }} {{ $t('LEGAL') }}:</b></p>
                  <vs-input
                    size="medium"
                    class="w-full"
                    name="Nome Representante"
                    id="nomeRepresentante"
                    v-model="form.dadosClientePessoal.representanteLegal"
                    v-validate="{ required: true }"
                    :state="validateState('Nome Representante')"
                    :danger="validateClass('Nome Representante')"
                    val-icon-danger="clear"
                    danger-text="Preencha este Campo"
                    :disabled="disableSwitch"
                  />
                </div>
              </div>
              <div class="mt-1">
                <p><b>{{ $t('CNH') }}:</b></p>
                <vs-input
                  size="medium"
                  class="w-full"
                  name="CNH"
                  id="CNH"
                  v-model="form.dadosClientePessoal.cnh"
                  v-validate="{ required: true, max: 11, min: 11 }"
                  :state="validateState('CNH')"
                  :danger="validateClass('CNH')"
                  val-icon-danger="clear"
                  danger-text="Preencha os 11 dígitos da CNH"
                  :disabled="disableSwitch"
                />
              </div>
              <div class="mt-1">
              <p><b>{{ $t('DATA') }} {{ $t('DE') }} {{ $t('VALIDADE') }}:</b></p>
                <vs-input
                  size="medium"
                  class="w-full"
                  name="Data de Validade"
                  id="dataValidade"
                  v-model="form.dadosClientePessoal.dataVencimentoCnh"
                  v-validate="{ required: true, date_format: 'dd/mm/yyyy' }"
                  :state="validateState('Data de Validade')"
                  :danger="validateClass('Data de Validade')"
                  val-icon-danger="clear"
                  danger-text="Preencha com uma data válida usando o formato DD/MM/AAAA"
                  :disabled="disableSwitch"
                />
              </div>
              <div class="mt-1">
                <p><b>{{ $t('EMAIL') }}:</b></p>
                <vs-input
                  size="medium"
                  class="w-full"
                  name="Email"
                  id="email"
                  v-model="form.dadosClientePessoal.email"
                  v-validate="{ required: true, email: true }"
                  :state="validateState('Email')"
                  :danger="validateClass('Email')"
                  val-icon-danger="clear"
                  danger-text="Preencha um email válido"
                  :disabled="disableSwitch"
                />
              </div>
              <div v-if="!disableSwitch">
               <vs-button
                 @click="onSubmit('dadosPessoais')"
                 color="success"
                 type="gradient"
                 class="mt-2 mb-2"
                 :disabled="disableSwitch"
               >
                 {{ $t('SALVAR') }} {{ $t('ALTERAÇÕES') }}
               </vs-button>
              </div>
            </div>
          </vs-col>
          <vs-col
            v-if="
              (itemModal.nomePosicao == 'DUT - Documento do Veículo' ||
                itemModal.nomePosicao == 'CRLV - Documento do Veículo') &&
              tipoModal == 'Foto'
            "
            vs-justify="center"
            vs-w="2"
            vs-align="center"
            class="mt-4"
          >
            <div class="mt-8">
              <div class="mt-1">
              <p><b>{{ $t('MARCA') }}:</b></p>
                <vs-input
                  size="medium"
                  class="w-full"
                  v-model="dadosProposta.dadosVeiculo.veiculoMarca"
                  :disabled="true"
                />
              </div>
              <div class="mt-1">
                <p><b>{{ $t('MODELO') }}:</b></p>
                <vs-input
                  size="medium"
                  class="w-full"
                  v-model="dadosProposta.dadosVeiculo.veiculoModelo"
                  :disabled="true"
                />
              </div>
              <div class="mt-1">
                <p><b>{{ $t('COMBUSTÍVEL') }}:</b></p>
                <vs-input
                  size="medium"
                  class="w-full"
                  v-model="dadosProposta.dadosVeiculo.combustivel"
                  :disabled="true"
                />
              </div>
              <div class="mt-1">
                <p><b>{{ $t('ANO') }} {{ $t('DE') }} {{ $t('FABRICAÇÃO') }}:</b></p>
                <vs-input
                  size="medium"
                  class="w-full"
                  v-model="dadosProposta.dadosVeiculo.anoFabricacao"
                  :disabled="true"
                />
              </div>
              <div class="mt-1">
                <p><b>{{ $t('ANO') }} {{ $t('DO') }} {{ $t('MODELO') }}:</b></p>
                <vs-input
                  size="medium"
                  class="w-full"
                  v-model="dadosProposta.dadosVeiculo.anoModelo"
                  :disabled="true"
                />
              </div>
              <div class="mt-1">
                <p><b>{{ $t('ANO') }} {{ $t('DE') }} {{ $t('EXERCÍCIO') }}:</b></p>
                <vs-input
                  size="medium"
                  class="w-full"
                  name="Ano de Exercicio"
                  id="anoExercicio"
                  v-model="form.dadosVeiculo.anoExercicioDut"
                  v-validate="{
                    required: true,
                    min: 4,
                    max: 4,
                    numeric: true,
                    date_format: 'yyyy',
                  }"
                  :state="validateState('Ano de Exercicio')"
                  :danger="validateClass('Ano de Exercicio')"
                  val-icon-danger="clear"
                  danger-text="Digite o ano com quatro dígitos"
                  :disabled="disableSwitch"
                />
              </div>
              <div class="mt-1">
                <p><b>{{ $t('RENAVAM') }}:</b></p>
                <vs-input
                  size="medium"
                  class="w-full"
                  name="Renavam"
                  id="renavam"
                  v-model="form.dadosVeiculo.renavam"
                  v-validate="{ required: true }"
                  :state="validateState('Renavam')"
                  :danger="validateClass('Renavam')"
                  val-icon-danger="clear"
                  danger-text="Preencha este Campo"
                  :disabled="disableSwitch"
                />
              </div>
              <div class="mt-1">
                <p><b>{{ $t('COR') }} {{ $t('PREDOMINANTE') }}:</b></p>
                <v-select
                  :options="listaCores"
                  name="Cor"
                  id="cor"
                  size="medium"
                  v-model="form.dadosVeiculo.cor"
                  v-validate="{ required: true }"
                  :state="validateState('Cor')"
                  :class="validateClass('Cor')"
                  :disabled="disableSwitch"
                ></v-select>
              </div>
              <div class="mt-1">
                <p><b>PLACA:</b></p>
                <vs-input
                  size="medium"
                  class="w-full"
                  name="Placa"
                  id="placa"
                  v-model="form.dadosVeiculo.placa"
                  v-validate="{ required: true }"
                  :state="validateState('Placa')"
                  :danger="validateClass('Placa')"
                  val-icon-danger="clear"
                  danger-text="Preencha este Campo"
                  :disabled="disableSwitch"
                />
              </div>
              <div class="mt-1">
                <p><b>{{ $t('TIPO') }} {{ $t('DE') }} {{ $t('CÂMBIO') }}:</b></p>
                <v-select
                  :options="listaCambios"
                  name="Tipo de Câmbio"
                  id="tipoCambio"
                  size="medium"
                  v-model="form.dadosVeiculo.tipoCambio"
                  v-validate="{ required: true }"
                  :state="validateState('Tipo de Câmbio')"
                  :class="validateClass('Tipo de Câmbio')"
                  :disabled="disableSwitch"
                ></v-select>
              </div>
              <div class="mt-1">
                <p><b>{{ $t('NÚMERO') }} {{ $t('DO') }} {{ $t('MOTOR') }}:</b></p>
                <vs-input
                  size="medium"
                  class="w-full"
                  name="Número do Motor"
                  id="numeroMotor"
                  v-model="form.dadosVeiculo.numeroMotor"
                  v-validate="{ required: true }"
                  :state="validateState('Número do Motor')"
                  :danger="validateClass('Número do Motor')"
                  val-icon-danger="clear"
                  danger-text="Preencha este Campo"
                  :disabled="disableSwitch"
                />
              </div>
              <div class="mt-1">
                <p><b>{{ $t('CHASSI') }}:</b></p>
                <vs-input
                  size="medium"
                  class="w-full"
                  name="Chassi"
                  id="chassi"
                  v-model="form.dadosVeiculo.chassi"
                  v-validate="{ required: true }"
                  :state="validateState('Chassi')"
                  :danger="validateClass('Chassi')"
                  val-icon-danger="clear"
                  danger-text="Preencha este Campo"
                  :disabled="disableSwitch"
                />
              </div>
             <div v-if="!disableSwitch">
               <vs-button
                 @click="onSubmit('dadosVeiculo')"
                 color="success"
                 type="gradient"
                 class="mt-2 mb-2"
                 :disabled="disableSwitch"
               >
                 {{ $t('SALVAR') }} {{ $t('ALTERAÇÕES') }}
               </vs-button>
             </div>
            </div>
          </vs-col>
          <vs-col
            v-if="
              itemModal.nomePosicao == 'Comprovante de Endereço' &&
              tipoModal == 'Foto'
            "
            vs-justify="center"
            vs-w="2"
            vs-align="center"
            class="mt-4"
          >
            <div class="mt-8">
              <div class="mt-1">
                <p><b>{{ $t('ENDEREÇO') }}:</b></p>
                <vs-input
                  size="medium"
                  class="w-full"
                  name="Endereço"
                  id="endereco"
                  v-model="form.dadosClienteEndereco.endereco"
                  v-validate="{ required: true }"
                  :state="validateState('Endereço')"
                  :danger="validateClass('Endereço')"
                  val-icon-danger="clear"
                  danger-text="Preencha este Campo"
                  :disabled="disableSwitch"
                />
              </div>
              <div class="mt-1">
                <p><b>{{ $t('NÚMERO') }}:</b></p>
                <vs-input
                  size="medium"
                  class="w-full"
                  name="Número"
                  id="numero"
                  v-model="form.dadosClienteEndereco.numero"
                  v-validate="{ required: true }"
                  :state="validateState('Número')"
                  :danger="validateClass('Número')"
                  val-icon-danger="clear"
                  danger-text="Preencha este Campo"
                  :disabled="disableSwitch"
                />
              </div>
              <div class="mt-1">
                <p>
                  <p><b>{{ $t('COMPLEMENTO') }}:</b></p>
                </p>
                <vs-input
                  size="medium"
                  class="w-full"
                  name="Complemento"
                  id="complemento"
                  v-model="form.dadosClienteEndereco.complemento"
                  :state="validateState('Complemento')"
                  :danger="validateClass('Complemento')"
                  val-icon-danger="clear"
                  danger-text="Preencha este Campo"
                  :disabled="disableSwitch"
                />
              </div>
              <div class="mt-1">
                <p><b>{{ $t('BAIRRO') }}:</b></p>
                <vs-input
                  size="medium"
                  class="w-full"
                  name="Bairro"
                  id="bairro"
                  v-model="form.dadosClienteEndereco.bairro"
                  v-validate="{ required: true }"
                  :state="validateState('Bairro')"
                  :danger="validateClass('Bairro')"
                  val-icon-danger="clear"
                  danger-text="Preencha este Campo"
                  :disabled="disableSwitch"
                />
              </div>
              <div class="mt-1">
                <p><b>{{ $t('CIDADE') }}:</b></p>
                <vs-input
                  size="medium"
                  class="w-full"
                  v-model="dadosProposta.dadosCliente.cidade"
                  :disabled="true"
                />
              </div>
              <div class="mt-1">
                <p><b>{{ $t('ESTADO') }}:</b></p>
                <vs-input
                  size="medium"
                  class="w-full"
                  v-model="dadosProposta.dadosCliente.estado"
                  :disabled="true"
                />
              </div>
              <div class="mt-1">
                <p><b>{{ $t('CEP') }}:</b></p>
                <vs-input
                  size="medium"
                  class="w-full"
                  v-model="dadosProposta.dadosCliente.cep"
                  :disabled="true"
                />
              </div>
              <div v-if="!disableSwitch">
                <vs-button
                  @click="onSubmit('dadosEndereco')"
                  color="success"
                  type="gradient"
                  class="mt-2 mb-2"
                  :disabled="disableSwitch"
                >
                  {{ $t('SALVAR') }} {{ $t('ALTERAÇÕES') }}
                </vs-button>
              </div>
            </div>
          </vs-col>
          <vs-col
            v-if="itemModal.nomePosicao == 'Chassi' && tipoModal == 'Foto'"
            vs-justify="center"
            vs-w="2"
            vs-align="center"
            class="mt-4"
          >
            <div class="mt-8">
              <div class="mt-1">
                <p><b>{{ $t('CHASSI') }}:</b></p>
                <vs-input
                  size="medium"
                  class="w-full"
                  name="Chassi"
                  id="chassi"
                  v-model="form.dadosVeiculo.chassi"
                  v-validate="{ required: true }"
                  :state="validateState('Chassi')"
                  :danger="validateClass('Chassi')"
                  val-icon-danger="clear"
                  danger-text="Preencha este Campo"
                  :disabled="disableSwitch"
                />
              </div>
            <vs-button
              @click="onSubmit('dadosVeiculo')"
              color="success"
              type="gradient"
              class="mt-2 mb-2"
              :disabled="disableSwitch"
            >
              {{ $t('SALVAR') }} {{ $t('ALTERAÇÕES') }}
            </vs-button>
            </div>
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            :vs-w="
              (itemModal.nomePosicao == 'CNH' ||
                itemModal.nomePosicao == 'DUT - Documento do Veículo' ||
                itemModal.nomePosicao == 'CRLV - Documento do Veículo' ||
                itemModal.nomePosicao == 'Comprovante de Endereço' ||
                itemModal.nomePosicao == 'Chassi') &&
              tipoModal == 'Foto'
                ? '10'
                : '12'
            "
            class="sm:p-2 p-4"
            :class="rotate"
          >
            <img
              v-if="verificaExtensaoImagem(imgModal)"
              :src="imgModal"
              :width="zoomFotoModal"
              :height="zoomFotoModal"
              style="max-width: 100%; max-height: 100%; object-fit: contain"
            />
            <video
              class="video"
              style="max-height: 800px; margin: auto; display: flex"
              v-if="verificaExtensaoVideo(imgModal)"
              controls
              muted
              loop
              :src="imgModal"
            ></video>
          </vs-col>
        </vs-row>
        <div v-if="itemModal.observacaoVistoria">
         <span :class="`${itemModal.aprovada == null ? '' : 'text-white'}`">
           <b>{{ $t('OBSERVAÇÃO') }}:</b>
         </span>
          <p
            :class="`${
              itemModal.aprovada == null
                ? 'break-words'
                : 'text-white break-words'
            }`"
          >
            {{ itemModal.observacaoVistoria }}
          </p>
        </div>
        <div
          class="flex justify-end gap-x-1"
          v-if="
            responsavelVistoria &&
            tipoModal == 'Foto' &&
            itemModal.aprovada == null
          "
        >
          <vs-button
            v-tooltip="'Recusar Foto'"
            type="gradient"
            color="danger"
            icon="thumb_down"
            @click="openPrompt(itemModal)"
          />
          <vs-button
            v-tooltip="'Aprovar Foto'"
            type="gradient"
            color="success"
            icon="thumb_up"
            @click="aprovarFoto(itemModal)"
          />
        </div>
        <!-- </form> -->
      </vs-popup>

      <vs-popup
        :title="'Motivo de Reprovação'"
        @cancel="motivoReprovacao = null"
        @close="activePrompt = false"
        :active.sync="activePrompt"
      >
        <div class="con-exemple-prompt">
          <vs-textarea
            placeholder="Motivo Reprovação"
            v-model="motivoReprovacao"
          />
        </div>
        <vs-button
          @click="reprovarFoto()"
          color="dark"
          class="mb-2 my-5 btn-block"
        >
          <span>{{ $t('Reprovar') }} {{ $t('Foto') }}</span>
        </vs-button>
      </vs-popup>

      <vs-popup
        title="Motivo da exclusão"
        @cancel="motivoExclusao = null"
        @close="activePromptDelete = false"
        :active.sync="activePromptDelete"
      >
        <div class="con-exemple-prompt">
          <vs-textarea placeholder="Motivo Exclusão" v-model="motivoExclusao" />
        </div>
        <vs-button
          @click.stop.prevent="softDeleteImg()"
          color="danger"
          class="mb-2 my-5 btn-block"
        >
          <span>{{ $t('Deletar') }}</span>
        </vs-button>
      </vs-popup>

      <vs-popup
        :title="'Motivo de Reprovação'"
        @cancel="motivoReprovacaoGeral = null"
        @close="activePromptGeral = false"
        :active.sync="activePromptGeral"
      >
        <div class="con-exemple-prompt">
          <span>{{ $t('Refazer') }} {{ $t('a') }} {{ $t('Assinatura') }}</span>
          <vs-switch
            color="success"
            v-model="refazerAssinatura"
            style="width: 60px"
          >
          <span slot="on">{{ $t('Sim') }}</span>
          <span slot="off">{{ $t('Não') }}</span>
          </vs-switch>
          <vs-textarea
            class="mt-5"
            placeholder="Motivo Reprovação"
            v-model="motivoReprovacaoGeral"
          />
        </div>
        <vs-button
          @click="reprovarGeral()"
          color="dark"
          class="mb-2 my-5 btn-block"
        >
          <span>{{ $t('Reprovar') }} {{ $t('Vistoria') }}</span>
        </vs-button>
      </vs-popup>

      <vs-popup
        :title="'Aprovar Cotação'"
        @cancel="diaVencimentoMensalidade = null"
        @close="activePromptGeralAprovar = false"
        :active.sync="activePromptGeralAprovar"
        class="popupMaior"
      >
        <div v-if="activePromptGeralAprovar">
          <div class="mb-4" v-if="!dadosProposta.dadosVeiculo.chassi">
         <vs-alert
           style="height: auto"
           title="Atenção"
           active="true"
           color="danger"
           class="mb-4"
         >
           {{ $t('A') }} {{ $t('Vistoria') }} {{ $t('esta') }} {{ $t('sem') }} {{ $t('os') }} {{ $t('dados') }} {{ $t('completos') }} {{ $t('do') }} {{ $t('veículo') }}
         </vs-alert>
          </div>
          <div v-else>
            <div
              v-if="!dadosProposta.assinatura && assinaturaLiberada == false"
            >
              <div class="mb-4">
             <vs-alert
               style="height: auto"
               title="Atenção"
               active="true"
               color="danger"
               class="mb-4"
             >
               {{ $t('A') }} {{ $t('Vistoria') }} {{ $t('esta') }} {{ $t('sem') }} {{ $t('assinatura,') }} {{ $t('solicite') }} {{ $t('ao') }} {{ $t('Beneficiário') }} {{ $t('que') }} {{ $t('faça') }} {{ $t('a') }} {{ $t('assinatura') }} {{ $t('pelo') }} {{ $t('APP') }} {{ $t('ou') }} {{ $t('procure') }} {{ $t('o') }} {{ $t('administrador') }} {{ $t('do') }} {{ $t('sistema') }} {{ $t('para') }} {{ $t('liberar') }} {{ $t('a') }} {{ $t('vistoria') }} {{ $t('sem') }} {{ $t('assinatura') }}.
             </vs-alert>
                <div class="vx-row mt-3" style="justify-content: space-evenly">
                  <div class="vs-col">
                    <div
                      v-if="
                        $can(
                          'Aprovar Vistoria sem Assinatura',
                          subjectPermission,
                        )
                      "
                    >
                      <span>{{ $t('Liberar') }} {{ $t('Assinatura') }}?</span>
                      <vs-switch
                        color="success"
                        v-model="assinaturaLiberada"
                        style="width: 60px"
                      >
                        <span slot="on">{{ $t('Sim') }}</span>
                        <span slot="off">{{ $t('Não') }}</span>
                      </vs-switch>
                    </div>
                  </div>
                  <div class="vx-coll">
                    <div
                      v-if="$can('Aprovar proposta sem vistoria', 'Cotações')"
                      v-show="fotosGerais.length > 0"
                    >
                      <span>{{ $t('Aprovar') }} {{ $t('propostas') }} {{ $t('sem') }} {{ $t('vistoria') }}?</span>
                      <vs-switch
                        color="success"
                        v-model="aprovarPropostaSemFotos"
                        style="width: 60px"
                      >
                        <span slot="on">{{ $t('Sim') }}</span>
                        <span slot="off">{{ $t('Não') }}</span>
                      </vs-switch>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="con-exemple-prompt">
              <div class="vx-row mb-6">
                <!-- Cliente vence todo dia: -->
                <div class="vx-col sm:w-1/2 w-full">
                  <label class="mt-4">{{ $t('Cliente') }} {{ $t('vence') }} {{ $t('todo') }} {{ $t('dia') }}:</label>
                  <v-select
                    :options="diasVencimento"
                    name="Cliente vence todo dia:"
                    id="Cliente vence todo dia:"
                    v-model="diaVencimentoMensalidade"
                    v-validate="{ required: true }"
                    :state="validateState('Cliente vence todo dia:')"
                    :class="validateClass('Cliente vence todo dia:')"
                  ></v-select>
                </div>

                <!-- Data de Ativação -->
                <div class="vx-col sm:w-1/2 w-full">
                  <label>{{ $t('Data') }} {{ $t('de') }} {{ $t('Ativação') }}</label>
                  <div>
                    <flat-pickr
                      name="Data de Ativação"
                      class="input-data-ativacao"
                      v-model="dataAdesaoRealAux"
                      :state="validateState('Data de Ativação')"
                      :class="validateClass('Data de Ativação')"
                      :config="configdateTimePickerDay"
                      placeholder="DD/MM/AAAA"
                    />
                  </div>
                </div>
              </div>

              <!-- Valores de Entrada -->
              <div class="vx-row mb-6">
                <div
                  v-if="somaValorTotal(dadosProposta.produtos) > 0"
                  class="vx-col sm:w-1/2 w-full"
                >
                  <label>{{ $t('Os') }} {{ $t('Valores') }} {{ $t('de') }} {{ $t('Entrada') }} {{ $t('vencem') }}:</label>
                  <div>
                    <flat-pickr
                      name="Data de Vencimento"
                      placeholder="DD/MM/AAAA"
                      class="w-full"
                      v-model="dataVencimentoAvistaAux"
                      :config="configdateTimePickerDayEntrada"
                    />
                  </div>
                </div>
              </div>

              <div class="vx-row" v-if="!verificaEmpresa()">
                <!-- Gera Cobrança? -->
                <div class="vx-col sm:w-1/3 w-full mb-2">
                  <span>{{ $t('Gera') }} {{ $t('Cobrança') }}?</span>
                  <vs-switch
                    color="success"
                    v-model="geraCobranca"
                    style="width: 60px"
                  >
                    <span slot="on">{{ $t('Sim') }}</span>
                    <span slot="off">{{ $t('Não') }}</span>
                  </vs-switch>
                </div>

                <!-- Participa do Rateio? -->
                <div class="vx-col sm:w-1/3 w-full mb-2">
                 <span>{{ $t('Participa') }} {{ $t('do') }} {{ $t('Rateio') }}?</span>
                  <vs-switch
                    color="success"
                    v-model="participaRateio"
                    style="width: 60px"
                  >
                  <span slot="on">{{ $t('Sim') }}</span>
                  <span slot="off">{{ $t('Não') }}</span>
                  </vs-switch>
                </div>

                <!-- Boleto Físico? -->
                <div class="vx-col sm:w-1/3 w-full mb-2">
                 <span>{{ $t('Boleto') }} {{ $t('Físico') }}?</span>
                  <vs-switch
                    color="success"
                    v-model="boletoFisico"
                    style="width: 60px"
                  >
                   <span slot="on">{{ $t('Sim') }}</span>
                   <span slot="off">{{ $t('Não') }}</span>
                  </vs-switch>
                </div>
              </div>

              <div
                v-if="
                  listPropostasConcorrentes.length > 0 &&
                  this.recusaPropostasConcorrentesAtivo
                "
              >
               <vs-alert color="danger" title="Atenção">
                 {{ $t('Ao') }} {{ $t('aprovar') }} {{ $t('essa') }} {{ $t('vistoria') }}, {{ $t('você') }} {{ $t('estará') }} {{ $t('recusando') }}
                 {{ $t('automaticamente') }} {{ $t('as') }} {{ $t('seguintes') }} {{ $t('propostas') }} {{ $t('que') }} {{ $t('possuem') }} {{ $t('o') }} {{ $t('mesmo') }}
                 {{ $t('veículo') }}:
               </vs-alert>
                <div class="mt-2">
                  <vs-table :data="listPropostasConcorrentes">
                    <template slot="thead">
                      <vs-th>{{ $t('Proposta') }}</vs-th>
                      <vs-th>{{ $t('Status') }}</vs-th>
                      <vs-th>{{ $t('Divisão') }}</vs-th>
                     <vs-th>{{ $t('Regional') }}</vs-th>
                      <vs-th>{{ $t('Consultor') }}</vs-th>
                    </template>

                    <template slot-scope="{ data }">
                      <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td :data="data[indextr].idProposta">
                          <a
                            class="cursor-pointer"
                            @click="
                              abreNovaJanelaProposta(data[indextr].idProposta)
                            "
                            >{{ data[indextr].idProposta }}</a
                          >
                        </vs-td>

                        <vs-td :data="data[indextr].nomeStatus">
                          {{ data[indextr].nomeStatus }}
                        </vs-td>

                        <vs-td :data="data[indextr].nomeDivisao">
                          {{ data[indextr].nomeDivisao }}
                        </vs-td>

                        <vs-td :data="data[indextr].nomeRegional">
                          {{ data[indextr].nomeRegional }}
                        </vs-td>

                        <vs-td :data="data[indextr].nomeConsultor">
                          {{ data[indextr].nomeConsultor }}
                        </vs-td>
                      </vs-tr>
                    </template>
                  </vs-table>
                </div>
              </div>

              <center>
                <vs-button
                  @click="aprovarGeral()"
                  color="success"
                  class="mb-12 mt-12 btn-block"
                >
                  <span>{{ $t('Aprovar') }} {{ $t('Vistoria') }}</span>
                </vs-button>
              </center>
            </div>
          </div>
        </div>
      </vs-popup>

      <vs-popup
        :title="'Erro ao Atualizar a Proposta'"
        @close="modalErrAprovacao = false"
        :active.sync="modalErrAprovacao"
      >
        <vs-alert
          style="height: auto"
          title="Atenção"
          active="true"
          color="danger"
        >
          <ul>
            <li v-for="item in errAprovacao" :key="item">{{ item }}</li>
          </ul>
        </vs-alert>

        <vs-button
          v-if="$can($actionsDefault.Escrita, subjectPermission)"
          @click="editarProposta()"
          color="success"
          type="gradient"
          icon-pack="feather"
          icon="icon-edit"
          class="d-inline mt-4"
        >
          {{ $t('Editar') }} {{ $t('Dados') }}
        </vs-button>
      </vs-popup>

      <vs-popup
        :title="'Upload Manual'"
        @close="modalUpload = false"
        :active.sync="modalUpload"
      >
        <vs-alert
          style="height: auto"
          title="Atenção"
          active="true"
          color="danger"
        >
          {{ $t('Ao') }} {{ $t('fazer') }} {{ $t('upload') }} {{ $t('manual') }}, {{ $t('você') }} {{ $t('assume') }} {{ $t('o') }} {{ $t('risco') }} {{ $t('por') }} {{ $t('possíveis') }} {{ $t('fraudes') }}.
        </vs-alert>
        <formUploadVistoria
          :fotos="fotosGerais"
          :idProposta="$route.params.idCotacao"
          @uploaded="uploaded"
          @fechaModalUploadManual="closeModalUploadManual"
        >
        </formUploadVistoria>
      </vs-popup>

      <vs-popup
        :title="'Logs do Sincronismo'"
        @close="activePromptSincronismo = false"
        :active.sync="activePromptSincronismo"
      >
        <vs-collapse type="border">
          <vs-collapse-item v-for="item in logs" :key="item.idLog">
            <div slot="header">
              {{ item.etapaSinc }}
              <vs-chip
                v-if="item.resultado == true"
                color="success"
                class="mr-3"
                >Sucesso</vs-chip
              >
              <vs-chip v-else color="danger" class="mr-3">Erro</vs-chip>
            </div>
            <div>EndPoint: {{ item.endpoint }}</div>
            <vs-tabs>
              <vs-tab label="Requisição">
                <div class="tab-text">
                  <div>
                    <vs-chip>{{
                      formataDataMilisegundos(item.dataRequisicao)
                    }}</vs-chip>
                  </div>
                  <br />
                  <br />

                  <vue-json-pretty
                    :path="'res'"
                    :data="retornaJson(item.requisicao)"
                  ></vue-json-pretty>
                </div>
              </vs-tab>
              <vs-tab label="Resposta">
                <div class="tab-text">
                  <div>
                    <vs-chip>{{
                      formataDataMilisegundos(item.dataResposta)
                    }}</vs-chip>
                  </div>
                  <br />
                  <br />
                  <vue-json-pretty
                    :path="'res'"
                    :data="retornaJson(item.resposta)"
                  ></vue-json-pretty>
                </div>
              </vs-tab>
              <vs-tab label="Header">
                <div class="tab-text">
                  <vue-json-pretty
                    :path="'res'"
                    :data="retornaJson(item.headers)"
                  ></vue-json-pretty>
                </div>
              </vs-tab>
            </vs-tabs>
          </vs-collapse-item>
        </vs-collapse>
      </vs-popup>

      <div>
        <vs-popup
          :title="titleSideBar"
          :active.sync="abrirModalSituacaoFinanceira"
          @close="fecharModalSituacaoFinanceira"
        >
          <div>
            <formSituacaoFinanceira
              :dados="dadosClienteFinanceiro"
            ></formSituacaoFinanceira>
          </div>
        </vs-popup>
      </div>

      <div>
        <ModalVeiculosEmpresaAntiga
          :dadosVeiculosEmpresaAntiga="dadosVeiculosEmpresaAntiga"
          @resposta="retornoModalVeiculosEmpresaAntiga"
        />
      </div>

      <div>
        <vs-popup
          :title="'Unificar Beneficiário'"
          :active.sync="abrirModalAssociadoUnificado"
          @close="fecharModalAssociadoUnificado(true)"
        >
          <div>
            <ModalAssociadoUnificado
              :dadosAssociadoUnificado="dadosAssociadoUnificado"
              :dadosProspect="dadosProposta.dadosCliente"
              @mostraFoto="mostraFoto"
              @unificar="unificarAssociados"
              @resposta="retornoModalVeiculosEmpresaAntiga"
              @closeModal="fecharModalAssociadoUnificado(true)"
            />
          </div>
        </vs-popup>
      </div>
      <div>
        <ModalListImgs
          :imgs="imgsDeletadas"
          :openModal="modalDeletedImgs"
          @close="closeDeletedImgs"
        />
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import jwt from 'jsonwebtoken';
import service from '../../services';
import functions from '../../utils/functions';
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';
import axios from 'axios';
import vSelect from 'vue-select';
import formUploadVistoria from './../forms/FormUploadFotoVistoria.vue';
import formSituacaoFinanceira from '../forms/formSituacaoFinanceira.vue';
import ModalVeiculosEmpresaAntiga from '../modais/ModalVeiculosEmpresaAntiga.vue';
import ModalAssociadoUnificado from '../modais/ModalAssociadoUnificado.vue';

import flatPickr from 'vue-flatpickr-component';
import { Portuguese } from 'flatpickr/dist/l10n/pt.js';
import dateConversion from '../../utils/dateConversion';

import notify from '../../utils/notify';
import FormMensagemVistoria from './../forms/formMensagemVistoria.vue';
import ModalListImgs from '../modais/ModalListImgs.vue';
import { decryptData } from '../../services/decryptData';
import {STATUS_COTACAO} from "@/commons/status-cotacao";
import {getTranslate} from "@/services/translate/translate";

export default {
  data() {
    return {
      functions: functions,
      formaPagamentoAtual: null,
      progressPercentage: null,
      progress: null,
      showProgressBar: false,
      implemento: false,
      agregado: false,
      disableSwitch: true,
      listaCores: [],
      listaCambios: ['Automático', 'Manual'],
      zoomFotoModal: '50%',
      zoomFotoSwitch: null,
      itemModal: null,
      itemModalIndex: null,
      tipoModal: null,
      rotate: 'transform rotate-0',
      implementos: [],
      agregados: [],
      idEmpresa: null,
      aprovarPropostaSemFotos: false,
      assinaturaLiberada: false,
      isAprovarTodas: null,
      promptAprovarReprovar: false,
      subjectPermission: 'Vistorias',
      isAdmin: false,
      isMounted: false,
      dadosProposta: {},
      logo: null,
      fotos: [],
      openModal: false,
      imgModal: null,
      isFullscreen: true,
      dataVencimentoAvistaAux: null,
      participaRateio: true,
      geraCobranca: true,
      boletoFisico: true,
      filtroFoto: 'Todas',
      tiposFotos: ['Todas', 'Aprovadas', 'Reprovadas', 'Não Trabalhadas'],
      motivoReprovacao: null,
      motivoReprovacaoGeral: '',
      diaVencimentoMensalidade: null,
      qtdRecusa: null,
      dataVencimentoAvista: null,
      refazerAssinatura: null,
      activePrompt: false,
      abrirModalSituacaoFinanceira: false,
      abrirModalAssociadoUnificado: false,
      aprovar: true,
      tamanhoModal: 'width: 900px',
      titleSideBar: 'Situação Financeira',
      dadosClienteFinanceiro: null,
      activePromptGeral: false,
      activePromptGeralAprovar: false,
      activePromptSincronismo: false,
      itemReprovado: null,
      tipoFoto: null,
      fotosGerais: [],
      logs: [],
      dadosFinanceiros: [],
      openModalMapa: false,
      itemMapaModal: null,
      errAprovacao: [],
      modalErrAprovacao: false,
      modalUpload: false,
      diasVencimento: [
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
        21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
      ],
      idUsuario: null,
      responsavelVistoria: false,
      verificarGrupo: false,
      dicionarioChassisNacionais: [],
      form: {
        dadosClientePessoal: {
          associado: null,
          rg_ie: null,
          cpfCnpj: null,
          dataNascimento: null,
          cnh: null,
          dataVencimentoCnh: null,
          email: null,
          idProspect: null,
          representanteLegal: null,
          cpfRepresentante: null,
        },
        dadosClienteEndereco: {
          endereco: null,
          numero: null,
          complemento: null,
          bairro: null,
          idProspect: null,
        },
        dadosVeiculo: {
          anoExercicioDut: null,
          renavam: null,
          cor: null,
          placa: null,
          tipoCambio: null,
          numeroMotor: null,
          chassi: null,
          idProposta: null,
          km: null,
        },
      },
      exibirDetalhesVistoria: false,
      itensNaoValidadosVistoria: [],
      dadosVeiculosEmpresaAntiga: null,
      dataAdesaoRealAux: new Date(),

      // Configurações de Component
      configdateTimePickerDay: {
        dateFormat: 'd/m/Y',
        locale: Portuguese,
        time_24hr: true,
      },
      configdateTimePickerDayEntrada: {
        dateFormat: 'd/m/Y',
        locale: Portuguese,
        time_24hr: true,
        disable: [
          function (date) {
            return date < new Date(new Date().setHours(0, 0, 0, 0));
          },
        ],
      },
      dadosAssociadoUnificado: null,
      necessitaUnificacao: null,
      itemDeletado: null,
      activePromptDelete: false,
      motivoExclusao: null,
      modalDeletedImgs: false,
      imgsDeletadas: [],
      deleteImgsPermission: 'Excluir fotos/arquivos da vistoria',
      listPropostasConcorrentes: [],
      recusaPropostasConcorrentesAtivo: false,
      travaFinalizarPropostaSemApolice: null,
      idsModelosFotosProposta: [],
      exigirCampoEstacionamentoProposta: true,
    };
  },
  watch: {
    filtroFoto: function () {
      this.filtraFotos();
    },
    aprovarPropostaSemFotos: function (newValue) {
      this.assinaturaLiberada = newValue;
    },
    zoomFotoSwitch: function () {
      if (this.zoomFotoSwitch) {
        this.zoomFotoModal = '100%';
      } else {
        this.zoomFotoModal = '50%';
      }
    },
    refazerAssinatura(valor) {
      if (valor) {
        this.motivoReprovacaoGeral += ' Favor refazer assinatura ';
      } else {
        this.motivoReprovacaoGeral = this.motivoReprovacaoGeral.replace(
          ' Favor refazer assinatura ',
          '',
        );
      }
    },
  },
  methods: {
    async translate(companyId) {
      const translate = await getTranslate(companyId);
      if (translate) {
        const nameDefaultLocale = `defaultLabels`;
        this.$i18n.mergeLocaleMessage(nameDefaultLocale, translate);
        this.$i18n.locale = nameDefaultLocale;
      }
    },
    async atualizaTipoFoto(item) {
      if (item.tipoAlterado) {
        const confirmar = confirm('Alterar Tipo de foto?');
        if (confirmar) {
          try {
            this.$vs.loading();

            await service
              .post('cotacao', 'altera-tipo-foto-proposta', {
                idPropostaFoto: item.id_PropostaFoto,
                idModeloFoto: item.tipoAlterado.id_modelofoto,
                tipo: item.tipoAlterado.tipoFoto,
              })
              .then(() => {
                this.$vs.notify({
                  position: 'top-center',
                  title: 'Tipo de Foto atualizada com sucesso!',
                  text: 'Recarregue a pagina para visualizar as alterações!',
                  color: 'success',
                });
                this.$vs.loading.close();
              });
          } catch (error) {
            this.$vs.notify({
              position: 'top-center',
              title: 'Falha ao Atualizar tipo de foto!',
              text: error,
              color: 'danger',
            });
            this.$vs.loading.close();
          } finally {
            this.$vs.loading.close();
          }
        }
      }
    },

    /**
     * Checks if the photo has been updated and returns the formatted date.
     * @param {Date} dataCriacao - The creation date.
     * @param {Date} dataAtualizacao - The update date.
     * @returns {string} - The formatted date.
     */
    verificaSefotoFoiAtualizada(dataCriacao, dataAtualizacao) {
      const fotoFoiAtualizada =
        moment(dataCriacao).format('YYYYMMDDHHMMSS') ===
        moment(dataAtualizacao).format('YYYYMMDDHHMMSS');

      const _dataFoto = !fotoFoiAtualizada
        ? this.ajustaDataHoraUtc(dataAtualizacao)
        : this.ajustaDataHoraUtc(dataCriacao);

      return _dataFoto;
    },
    filtraProdutosSelecionadosAgregado(idPropostaComplemento) {
      const { produtosAgregado } = this.agregados.find(
        (item) => item.idPropostaComplemento === idPropostaComplemento,
      );

      return produtosAgregado;
    },

    /**
     * Checks if the provided link is a data image or a supported image format.
     * @param {string} link - The link to check.
     * @returns {boolean} - True if the link is a data image or supported image format, false otherwise.
     */
    verificaExtensaoImagem(link) {
      if (link) {
        const hasDataImage = link.split('/')[0] === 'data:image';
        if (hasDataImage) {
          return hasDataImage;
        }
        const extension = link.split('.').pop();
        this.tipoFoto = extension;
        const isPhoto =
          extension === 'png' ||
          extension === 'jpeg' ||
          extension === 'jpg' ||
          extension === 'gif';
        return isPhoto;
      }
      return false;
    },

    /**
     * Checks if the provided link is a data video or a supported video format.
     * @param {string} link - The link to check.
     * @returns {boolean} - True if the link is a data video or supported video format, false otherwise.
     */
    verificaExtensaoVideo(link) {
      if (link) {
        const hasDataVideo = link.split('/')[0] === 'data:video';
        if (hasDataVideo) {
          return hasDataVideo;
        }
        const ext = link.split('.').pop();
        this.tipoFoto = ext;
        const isVideo =
          ext === 'gif' ||
          ext === 'mp4' ||
          ext === 'webm' ||
          ext === 'quicktime';
        return isVideo;
      }
      return false;
    },

    /**
     * Formats the given URL link.
     * @param {string} url - The URL to format.
     * @returns {string} - The formatted URL.
     */
    formataUrlLink(url) {
      if (url) return url.split('/').pop();
    },
    async uploaded() {
      await this.buscaFotos();
      this.buscaFotosPorProposta();
    },
    editarProposta() {
      const link = `/editarCotacao2/${this.$route.params.idCotacao}`;

      this.$router.push(link);
      this.modalErrAprovacao = false;
    },
    verificaAdmin() {
      const token = localStorage.getItem('user-token');
      if (token) {
        const decoded = jwt.decode(token);
        this.idEmpresa = decoded.id_empresa;
        this.idUsuario = decoded.id_usuario;
        if (decoded.nomePerfil == 'Super User') this.isAdmin = true;
      }
    },
    getStatusBoletoColor(data) {
      if (data == 'Finalizado') return 'success';
      if (data == 'Em Aberto') return 'warning';
      if (data == 'Em Processamento') return 'primary';
      if (data == 'Processado com Falha') return 'danger';
      if (data == 'Cancelado') return 'danger';
      if (data == 'Não Processado') return 'dark';
      return 'danger';
    },
    validaVencido(item) {
      if (item.nomeStatus != 'Finalizado' && item.nomeStatus != 'Cancelado') {
        if (moment().diff(moment(item.dataVencimento), 'days') > 0) return true;
      }
      return false;
    },
    formataLink(link) {
      if (!link) return '--';
      if (link.substring(0, 4) == 'http') {
        return '<a href="' + link + '" target="_blank">link</a> ';
      } else return '<span>' + link + '</span>';
    },
    formataData(data) {
      return moment(data).format('DD/MM/YYYY HH:mm');
    },
    formataDataUTC(data) {
      return moment(data).utc().format('DD/MM/YYYY HH:mm');
    },
    formataDataUTCAux(data) {
      return moment(data).utc().format('DD/MM/YYYY');
    },
    formataDataMilisegundos(data) {
      return moment(data).format('DD/MM/YYYY HH:mm:ss:SSS');
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    retornaJson(str) {
      return JSON.parse(str);
    },
    aprovaReprovaTodas() {
      this.$vs.loading();
      var objSend = {};
      objSend.idProposta = this.$route.params.idCotacao;
      objSend.isAprovarTodas = this.isAprovarTodas;
      var filtered = this.fotos.filter((x) => x.aprovada == null);
      filtered.forEach((element) => {
        element.aprovada = this.isAprovarTodas;
      });
      service
        .post('Cotacao', 'aprovarReprovarTodasFotos', objSend)
        .then(() => {
          var filtered = this.fotos.filter((x) => x.aprovada == null);
          filtered.forEach((element) => {
            element.aprovada = this.isAprovarTodas;
          });
          this.promptAprovarReprovar = false;
          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.promptAprovarReprovar = false;
          this.$vs.loading.close();
        });
    },
    exibeLogs() {
      this.activePromptSincronismo = true;
      var objSend = {};
      objSend.idProposta = this.$route.params.idCotacao;
      this.$vs.loading();
      service
        .post('Cotacao', 'buscaLogsSinc', objSend)
        .then((res) => {
          this.logs = res.data;
          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },
    resync() {
      var objSend = {};
      objSend.idProposta = this.$route.params.idCotacao;
      this.$vs.loading();
      service
        .post('Cotacao', 'resync', objSend)
        .then(() => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Cotação Resincronizada com Sucesso',
            color: 'success',
          });
          this.buscaDados();
          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },
    print() {
      window.print();
    },
    retornaAcessorios(acessorios) {
      return acessorios
        .map((el) => {
          return ' ' + el.descricao;
        })
        .toString();
    },
    cotacaoReprovar() {
      this.activePromptGeral = true;
    },

    async reprovarGeral() {
      this.activePromptGeral = false;

      try {
        await this.buscaFotosPorProposta();

        const fotosRecusadas = this.fotosGerais.filter(
          (foto) => foto.aprovada === false,
        );

        if (fotosRecusadas.length) {
          const promises = fotosRecusadas.map((foto) => {
            const fotoRecusada = {
              id_propostaFoto: foto.id_PropostaFoto,
              id_proposta: this.dadosProposta.idProposta,
              tipo: foto.tipoFoto,
              url: foto.nome,
              id_modeloFoto: foto.id_modelofoto,
              latitude: foto.latitude,
              longitude: foto.longitude,
              createdAt: foto.createdAt,
              motivoReprovacao: foto.motivoReprovacao,
              obrigatorio: foto.obrigatorio,
            };

            return service.post(
              'vistoria',
              'inserirFotoRecusada',
              fotoRecusada,
            );
          });

          await Promise.all(promises);
        }
        this.alteraStatusCotacao(STATUS_COTACAO.PENDENTE);
        this.$vs.loading.close();
      } catch (error) {
        this.$vs.loading.close();

        this.$vs.notify({
          position: 'top-center',
          title: 'Erro',
          text: error.message || 'Erro ao reprovar geral',
          color: 'danger',
        });
      }
    },

    cotacaoAprovar() {
      const filtered = this.fotos.filter(
        (x) => x.aprovada == null && x.obrigatorio == false,
      );

      if (filtered.length > 0) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Não foi possível Aprovar a Cotação, existem fotos não Trabalhadas',
          color: 'danger',
        });
      } else {
        this.situacaoFinanceira();

        /**/
      }
    },
    aprovarGeral() {
      const recusaPropostasConcorrentes =
        this.listPropostasConcorrentes.length > 0 &&
        this.recusaPropostasConcorrentesAtivo;

      const travaFinalizarPropostaSemApoliceAtiva =
        this.travaFinalizarPropostaSemApolice &&
        !this.dadosProposta.numeroApolice;

      if (!this.diaVencimentoMensalidade) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Não foi possível Aprovar a Cotação, Preencha o dia de Vencimento',
          color: 'danger',
        });
      } else {
        this.activePromptGeralAprovar = false;
        this.abrirModalSituacaoFinanceira = false;

        if (travaFinalizarPropostaSemApoliceAtiva) {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Não é possível aprovar uma proposta sem apólice.',
            color: 'danger',
            time: 5000,
          });
          return;
        }

        this.buscaFotosPorProposta().then(() => {
          const temFotosObrigatorias = this.fotosGerais.filter(
            (foto) => foto.obrigatorio,
          );

          if (temFotosObrigatorias.length == 0) {
            if (recusaPropostasConcorrentes) this.recusaPropostasConcorrentes();
            this.alteraStatusCotacao(4);
            return;
          }

          if (this.fotosGerais.length >= 0 && this.aprovarPropostaSemFotos) {
            if (recusaPropostasConcorrentes) this.recusaPropostasConcorrentes();
            this.alteraStatusCotacao(4);
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: 'Proposta aprovada sem vistoria',
              color: 'warning',
              time: 5000,
            });
            return;
          }

          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Não foi possível Aprovar a Cotação, existem fotos Reprovadas',
            color: 'danger',
          });
        });
      }
    },
    alteraStatusCotacao(status) {
      var objSend = {};
      objSend.idProposta = this.$route.params.idCotacao;
      objSend.idStatus = status;
      objSend.qtdRecusa = this.dadosProposta.qtdRecusa
        ? this.dadosProposta.qtdRecusa
        : 0;

      if (status == 4) {
        objSend.motivoReprovacaoGeral = null;
        objSend.refazerAssinatura = null;
        objSend.diaVencimentoMensalidade = this.diaVencimentoMensalidade;
        objSend.dataVencimentoAvista = this.dataVencimentoAvistaAux;
        objSend.participaRateio = this.participaRateio;
        objSend.geraCobranca = this.geraCobranca;
        objSend.boletoFisico = this.boletoFisico;
        objSend.dataAdesaoReal = moment(this.dataAdesaoRealAux, 'DD/MM/YYYY')
          .utc()
          .format('YYYY-MM-DD');
        this.uploadPdfContrato();
      }
      if (status == 5) {
        objSend.motivoReprovacaoGeral = this.motivoReprovacaoGeral;
        (objSend.idUsuario = this.dadosProposta.dadosVendedor.idUsuario),
          (objSend.qtdRecusa = objSend.qtdRecusa + 1);
      }
      objSend.motivoReprovacaoGeral = this.motivoReprovacaoGeral;
      objSend.refazerAssinatura = this.refazerAssinatura;
      objSend.assinaturaLiberada = this.assinaturaLiberada;
      this.$vs.loading();
      service
        .post('Cotacao', 'alteraStatusCotacao', objSend)
        .then((res) => {
          if (res.data.success == true) {
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: 'Cotação Atualizada com Sucesso',
              color: 'success',
            });
            this.buscaDados();
          } else {
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: 'Falha ao Atualizar Proposta',
              color: 'danger',
            });
            this.errAprovacao = res.data.err;
            this.modalErrAprovacao = true;
          }
          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },

    openPrompt(item) {
      this.activePrompt = true;
      this.itemReprovado = item;
    },

    openPromptDelete(item) {
      this.activePromptDelete = true;
      this.itemDeletado = item;
    },
    aprovarFoto(item) {
      this.$vs.loading();
      service
        .post('Cotacao', 'aprovarFoto', item)
        .then(() => {
          const filtered = this.fotos.filter(
            (image) => image.id_PropostaFoto === item.id_PropostaFoto,
          );
          if (filtered.length) {
            filtered[0].aprovada = true;
          }

          const allProcessed = this.fotos.every(
            (image) => image.aprovada !== null,
          );

          if (allProcessed) {
            const groupedByModelo = this.fotos.reduce((acc, image) => {
              acc[image.id_modeloFoto] = acc[image.id_modeloFoto] || [];
              acc[image.id_modeloFoto].push(image);
              return acc;
            }, {});

            const hasUnapproved = Object.values(groupedByModelo).some((group) =>
              group.every((image) => image.aprovada === false),
            );

            if (!hasUnapproved) {
              this.activePromptGeralAprovar = true;
            }
          }

          this.openModal = false;
          this.$vs.loading.close();
        })
        .catch((error) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: error.message || 'Ocorreu um erro',
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },
    reprovarFoto() {
      this.$vs.loading();
      this.itemReprovado.motivoReprovacao = this.motivoReprovacao;
      service
        .post('Cotacao', 'reprovarFoto', this.itemReprovado)
        .then(() => {
          var filtered = this.fotos.filter(
            (x) => x.id_PropostaFoto == this.itemReprovado.id_PropostaFoto,
          );
          filtered[0].aprovada = false;
          filtered[0].motivoReprovacao = this.motivoReprovacao;
          this.activePrompt = false;
          this.itemReprovado = null;
          this.motivoReprovacao = null;
          this.openModal = false;
          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },
    validTypeOfEndereco(item) {
      return typeof item == 'string';
    },
    filtraFotos() {
      let fotos = [];
      if (this.filtroFoto != 'Todas') {
        const aprovadas = this.filtroFoto === 'Aprovadas';
        const reprovadas = this.filtroFoto === 'Reprovadas';
        const naoTrabalhadas = this.filtroFoto === 'Não Trabalhadas';

        if (aprovadas) {
          fotos = this.fotos.filter((image) => image.aprovada && image.nome);
        }
        if (reprovadas) {
          fotos = this.fotos.filter(
            (image) => image.aprovada === false && image.nome,
          );
        }
        if (naoTrabalhadas) {
          fotos = this.fotos.filter(
            (image) => image.aprovada === null && image.nome,
          );
        }
      } else {
        fotos = this.fotos.filter((image) => image.nome);
      }

      fotos = fotos.map((foto) => {
        foto = { ...foto, fotosGerais: this.fotosGerais };
        return foto;
      });

      return fotos;
    },
    verificaBg(item) {
      if (item.aprovada == null) return '';
      if (item.aprovada == true) return 'bg-success';
      if (item.aprovada == false) return 'bg-danger';
    },
    openModalFoto(tipo, item) {
      if (
        this.$can(
          'Editar Informações Da Proposta na Foto da Vistoria',
          this.subjectPermission,
        ) &&
        this.dadosProposta.idStatus != 4
      ) {
        this.disableSwitch = false;
      }
      this.preencheForm();
      this.imgModal = item.nome;
      this.isFullscreen = true;
      this.itemModal = item;
      this.tipoModal = 'Foto';
      this.itemModalIndex = this.fotos.findIndex(
        (foto) => foto == this.itemModal,
      );
      this.rotate = 'transform rotate-0';
      if (tipo == 'Padrão') {
        this.tipoModal = 'Padrão';
        this.imgModal =
          'https://bboneapp.s3.amazonaws.com/imgsPadrao/' + item.fotoPadrao;
        this.isFullscreen = false;
      }
      this.openModal = true;
    },
    openModalMap(item) {
      this.itemMapaModal = item;
      this.openModalMapa = true;
    },
    closePop() {
      this.openModal = false;
    },
    somaValorTotal(produtos) {
      if (!produtos) return;

      var total = 0;
      produtos.forEach((element) => {
        if (element.isMensal != true) total = total + element.valorFinal;
      });

      if (this.agregado && !this.dadosProposta.unificarAgregados) {
        this.agregados.forEach((agregado) => {
          const { produtosAgregado } = agregado;

          const totalProdutosAgregado = produtosAgregado.reduce(
            (totalSomaProdAgregados, produto) => {
              if (produto.isMensal == false) {
                totalSomaProdAgregados += produto.valorFinal;
              }

              return totalSomaProdAgregados;
            },
            0,
          );

          total += totalProdutosAgregado;
        });
      }

      return total;
    },
    somaValorTotalMes(produtos) {
      if (!produtos) return;

      var total = 0;
      produtos.forEach((element) => {
        if (element.isMensal == true) total = total + element.valorFinal;
      });

      if (this.agregado && !this.dadosProposta.unificarAgregados) {
        this.agregados.forEach((agregado) => {
          const { produtosAgregado } = agregado;

          const totalProdutosAgregado = produtosAgregado.reduce(
            (totalSomaProdAgregados, produto) => {
              if (produto.isMensal) {
                totalSomaProdAgregados += produto.valorFinal;
              }

              return totalSomaProdAgregados;
            },
            0,
          );

          total += totalProdutosAgregado;
        });
      }

      return total;
    },
    calcularTotalComissao() {
      const totalComissaoAgregados = this.agregados.reduce(
        (total, { valorComissaoAplicadaFinal = 0 }) => {
          return total + valorComissaoAplicadaFinal;
        },
        0,
      );

      return (
        totalComissaoAgregados +
        (this.dadosProposta.valorComissaoAplicadaFinal || 0)
      );
    },
    async buscaFotos() {
      try {
        const objSend = {};
        objSend.idProposta = this.$route.params.idCotacao;

        const { data } = await service.post(
          'CotacaoAberta',
          'listarFotosCotacao',
          objSend,
        );

        this.isMounted = true;
        this.fotos = [];
        const arrPromess = [];
        this.imgsDeletadas = [];

        data.forEach((img) => {
          img.endereco = 'Não identificado';
          if (img.latitude) {
            img.endereco = 'Carregando endereço...';
            const sendLocal = this.reverseCoordenates(img);
            arrPromess.push(sendLocal);
          }
          if (img.dataExclusao) {
            this.imgsDeletadas.push(img);
            return;
          }
          this.fotos.push(img);
        });

        const localizacaoImg = await Promise.allSettled(arrPromess);

        localizacaoImg.forEach((img) => {
          const hasReasonAndExcludeDate =
            img.reason && img.reason.element.dataExclusao;

          const imagens = hasReasonAndExcludeDate
            ? this.imgsDeletadas
            : this.fotos;

          if (img.status === 'fulfilled') {
            const element = imagens.find(
              (image) =>
                image.id_PropostaFoto === img.value.element.id_PropostaFoto,
            );
            element.endereco = img.value.res.data.address;
            return;
          }

          const element = imagens.find(
            (image) =>
              image.id_PropostaFoto === img.reason.element.id_PropostaFoto,
          );

          element.endereco =
            'Não foi Possível Reverter Latitude, consulte o Mapa';
        });
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: error,
          color: 'danger',
        });
        this.$vs.loading.close();
      }
    },
    async buscaFotosPorProposta() {
      try {
        this.$vs.loading();
        const objSend = {
          idProposta: this.$route.params.idCotacao,
          idEmpresa: this.dadosProposta.idEmpresa,
          idGrupo: this.dadosProposta.idGrupo,
          idTipoFipe: this.dadosProposta.dadosVeiculo.codTipoVeiculo,
          isZero: this.dadosProposta.isZero,
        };

        const { data } = await service.post(
          'Cotacao',
          'listarTiposFotos',
          objSend,
        );
        this.fotosGerais = data;

        this.$vs.loading.close();
      } catch (err) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: err,
          color: 'danger',
        });
        this.$vs.loading.close();
      }
    },
    reverseCoordenates(element) {
      return new Promise((resolve, reject) => {
        var end = `https://nominatim.openstreetmap.org/reverse?&format=json&lat=${element.latitude}&lon=${element.longitude}&zoom=21&addressdetails=1`;
        axios
          .get(end)
          .then((res) => {
            resolve({ element, res });
          })
          .catch((e) => {
            reject({ element, e });
          });
      });
    },
    buscaDadosFinanceiros() {
      this.$vs.loading();
      var objSend = {};
      objSend.idProposta = this.$route.params.idCotacao;
      objSend.qtdPorPagina = this.itemsPerPage;
      objSend.idEmpresa = this.idEmpresa;
      this.logo = localStorage.getItem('logo');
      service
        .post('Financeiro', 'BuscaDadosFinanceirosProposta', objSend)
        .then((res) => {
          if (res.data.length > 0) {
            this.dadosFinanceiros = res.data;

            this.formaPagamentoAtual = this.dadosFinanceiros.reduce(
              (anterior, atual) => {
                return anterior.id_registroFinanceiro >
                  atual.id_registroFinanceiro
                  ? anterior
                  : atual;
              },
            );

            this.$vs.loading.close();
          } else {
            this.dadosFinanceiros = [];
          }
        })
        .catch(() => {
          this.dadosFinanceiros = [];
          this.$vs.loading.close();
        });
    },
    async buscaDados() {
      this.$vs.loading();
      var objSend = {};
      objSend.idProposta = this.$route.params.idCotacao;
      objSend.qtdPorPagina = this.itemsPerPage;
      objSend.idEmpresa = this.idEmpresa;
      this.logo = localStorage.getItem('logo');

      if (objSend.idProposta)
        try {
          const res = await service.post('Cotacao', 'listarCotacoes', objSend);

          if (res.data.length > 0) {
            this.dadosProposta = res.data[0];
            if (res.data[0].implementos) {
              this.implemento = true;
              this.implementos = res.data[0].implementos;
            }
            if (res.data[0].agregados) {
              this.agregados = res.data[0].agregados;
              this.agregado = true;
            }
            this.diaVencimentoMensalidade =
              this.dadosProposta.diaVencimentoMensalidade;

            if (!this.dadosProposta.dataVencimentoAvista) {
              const proximaDataUtil = moment(
                dateConversion.proximoDiaUtil(),
              ).format('DD/MM/YYYY');
              this.dataVencimentoAvistaAux = proximaDataUtil;
            } else {
              this.dataVencimentoAvistaAux = dateConversion.converteISOToDate(
                this.dadosProposta.dataVencimentoAvista,
              );
            }

            //this.buscaFotosPorProposta();
            this.$vs.loading.close();
          } else {
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: 'Você não tem acesso a visualização desta Proposta/Vistoria',
              color: 'danger',
            });
            this.$vs.loading.close();
          }
          if (res.data[0].agregados) {
            this.agregados = res.data[0].agregados;
            this.agregado = true;
          }

          this.diaVencimentoMensalidade =
            this.dadosProposta.diaVencimentoMensalidade;

          await this.buscaFotosPorProposta();

          this.verificarResponsavelVistoria(this.dadosProposta.idResponsavel);
          this.verificaEmpresa() && this.verificaGrupoImportados();

          await this.obterDetalhesVistoria();
          await this.buscaConfigEmpresa();
          this.$vs.loading.close();
        } catch (error) {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: error,
            color: 'danger',
          });
          this.$vs.loading.close();
        }
    },
    verificaEmpresa() {
      return functions.verificaEmpresaBemProtege(this.idEmpresa);
    },
    buscarDicionarioChassisNacionais() {
      service
        .post('dicionarios', 'buscar-dicionario-chassis-nacionais', {})
        .then((res) => {
          this.dicionarioChassisNacionais = res.data;
        })
        .catch((e) => {
          throw new Error(e);
        });
    },
    async verificaGrupoImportados() {
      const veiculoImportado = this.verificaVeiculoImportado();
      const { grupoVeiculosImportados } = this.dadosProposta;
      if (
        (this.verificarGrupoIncorreto(
          veiculoImportado,
          grupoVeiculosImportados,
        ) &&
          (await this.verificarSeExisteGrupoImportado())) ||
        this.verificaPedidoObservacaoGrupo()
      ) {
        this.verificarGrupo = true;
      }
    },
    verificarGrupoIncorreto(veiculoImportado, grupoVeiculosImportados) {
      return (
        (veiculoImportado && !grupoVeiculosImportados) ||
        (!veiculoImportado && grupoVeiculosImportados)
      );
    },
    async verificarSeExisteGrupoImportado() {
      const grupos = await this.buscaGrupos();
      const grupoImportado = grupos.find(
        (grupo) =>
          grupo.importado &&
          this.dadosProposta.dadosVeiculo.codTipoVeiculo === grupo.idTipoFipe,
      );
      return grupoImportado ? true : false;
    },
    verificaVeiculoImportado() {
      if (!this.dadosProposta.dadosVeiculo.chassi) return;

      if (this.dadosProposta.dadosVeiculo.chassi) {
        const chassi = this.dadosProposta.dadosVeiculo.chassi.slice(0, 2);
        return !this.dicionarioChassisNacionais.includes(chassi.toUpperCase());
      } else {
        return false;
      }
    },
    removePedidoRevisaoGrupo() {
      const { observacao, idProposta } = this.dadosProposta;
      if (!observacao) {
        return;
      }

      const fraseRemovida = '. Por favor, revise o grupo';
      const posicaoInicioFraseRemovida = observacao.indexOf(fraseRemovida);
      //a função indexOf retorná a posição na qual começa a frase a ser removida, caso não exista, retornará -1
      if (posicaoInicioFraseRemovida !== -1) {
        const posicaoFimFraseRemovida =
          posicaoInicioFraseRemovida + fraseRemovida.length;

        const novaObservacao =
          observacao.substring(0, posicaoInicioFraseRemovida) +
          observacao.substring(posicaoFimFraseRemovida);

        this.dadosProposta.observacao = novaObservacao;

        this.requsicaoPost(
          { idProposta, observacao: novaObservacao },
          'Grupo',
          'atualiza-tabela-proposta',
        );
      }
    },
    verificaPedidoObservacaoGrupo() {
      const { observacao } = this.dadosProposta;
      const pedidoObservacao = '. Por favor, revise o grupo.';
      return observacao ? observacao.includes(pedidoObservacao) : false;
    },
    requsicaoPost(body, rota, subRota) {
      return service
        .post(rota, subRota, body)
        .then((res) => res.data)
        .catch((e) => {
          throw new Error(e);
        });
    },
    buscaGrupos() {
      const idEmpresa = localStorage.getItem('idEmpresa');
      return service.getAll('Grupo', {}, 'list/' + idEmpresa).then((res) => {
        return res.data.filter((grupo) => grupo.deletedAt === null);
      });
    },
    verificarResponsavelVistoria(id) {
      if (
        this.$can('Assumir Responsabilidade', 'Vistorias') &&
        id === this.idUsuario
      ) {
        this.responsavelVistoria = true;
      }
    },

    async buscaConfigEmpresa() {
      try {
        this.$vs.loading();
        const { data } = await service.getAll(
          'g',
          {},
          'empresas/list/idEmpresa/idEmpresa=null',
        );

        const [dadosEmpresa] = decryptData(data);

        if (dadosEmpresa) {
          this.diasVencimento = dadosEmpresa.diasVencimento.split(',');
          this.recusaPropostasConcorrentesAtivo =
            dadosEmpresa.recusaPropostasConcorrentes;
          this.travaFinalizarPropostaSemApolice =
            dadosEmpresa.travaFinalizarPropostaSemApolice;
        }

        this.$vs.loading.close();
      } catch (error) {
        throw new Error(error);
      }
    },
    rotateRight() {
      if (this.rotate == 'transform rotate-0') {
        this.rotate = 'transform rotate-90';
        return;
      }
      if (this.rotate == 'transform rotate-90') {
        this.rotate = 'transform rotate-180';
        return;
      }
      if (this.rotate == 'transform rotate-180') {
        this.rotate = 'transform -rotate-90';
        return;
      }
      if (this.rotate == 'transform -rotate-90') {
        this.rotate = 'transform rotate-0';
        return;
      }
    },
    rotateLeft() {
      if (this.rotate == 'transform rotate-0') {
        this.rotate = 'transform -rotate-90';
        return;
      }
      if (this.rotate == 'transform -rotate-90') {
        this.rotate = 'transform rotate-180';
        return;
      }
      if (this.rotate == 'transform rotate-180') {
        this.rotate = 'transform rotate-90';
        return;
      }
      if (this.rotate == 'transform rotate-90') {
        this.rotate = 'transform rotate-0';
        return;
      }
    },
    mudaFoto(param) {
      // this.itemModalIndex = this.fotos.findIndex((foto => foto == this.itemModal))
      if (param === 'próximo' && this.itemModalIndex < this.fotos.length - 1) {
        this.itemModal = this.fotos[this.itemModalIndex + 1];
      }
      if (param === 'próximo' && this.itemModalIndex == this.fotos.length - 1) {
        this.itemModal = this.fotos[0];
      }
      if (param === 'anterior' && this.itemModalIndex > 0) {
        this.itemModal = this.fotos[this.itemModalIndex - 1];
      }
      if (param === 'anterior' && this.itemModalIndex == 0) {
        this.itemModal = this.fotos[this.fotos.length - 1];
      }
      this.openModalFoto('Foto', this.itemModal);
    },
    calculaValoresAgregado(isMensal) {
      let total = 0;
      this.agregados.forEach((agregado) => {
        const { produtosAgregado } = agregado;
        const totalProdutosAgregado = produtosAgregado.reduce(
          (totalSomaProdAgregados, produto) => {
            if (produto.isMensal == isMensal) {
              totalSomaProdAgregados += produto.valorFinal;
            }
            return totalSomaProdAgregados;
          },
          0,
        );
        total += totalProdutosAgregado;
      });
      return total;
    },
    situacaoFinanceira(financeiro) {
      this.dadosClienteFinanceiro = this.dadosProposta;
      this.abrirModalSituacaoFinanceira = true;
      // this.tamanhoModal = 'w-4/5';
      if (financeiro == 'Financeiro') {
        this.aprovar = false;
      } else {
        this.aprovar = true;
      }
    },
    fecharModalSituacaoFinanceira() {
      this.abrirModalSituacaoFinanceira = false;

      if (this.aprovar == true) {
        this.activePromptGeralAprovar = true;
        if (this.recusaPropostasConcorrentesAtivo)
          this.buscaPropostasConcorrentes();
      }
    },
    fecharModalAssociadoUnificado(fecharGeral) {
      this.abrirModalAssociadoUnificado = false;

      if (!fecharGeral) {
        this.activePromptGeralAprovar = true;
      }
    },
    buscaCoresECombustivel() {
      this.carregando = true;
      service
        .post('Cotacao', 'listarCoresECombustivel', {
          idRegional: this.dadosProposta.idRegional,
          idProposta: this.$route.params.idCotacao,
        })
        .then((res) => {
          this.listaCores.push({ label: 'Selecione', id: null });
          // this.listaCombustiveis.push({ label: 'Selecione', id: null });

          res.data.cores.forEach((element) => {
            this.listaCores.push({
              label: element.descricao,
              id: element.descricao,
            });
          });

          // res.data.combustiveis.forEach((element) => {
          //   this.listaCombustiveis.push({
          //     label: element.descricao,
          //     id: element.descricao,
          //   });
          // });

          this.carregando = false;
        });
    },
    onSubmit(tipo) {
      let objSend = {};

      if (tipo == 'dadosPessoais') {
        objSend.dadosClientePessoal = this.form.dadosClientePessoal;
      }

      if (tipo == 'dadosVeiculo') {
        objSend.dadosVeiculo = this.form.dadosVeiculo;
      }

      if (tipo == 'dadosEndereco') {
        objSend.dadosClienteEndereco = this.form.dadosClienteEndereco;
      }

      this.$validator.validateAll().then((result) => {
        if (result) {
          this.aguardeCadastro = true;
          this.$vs.loading();
          service
            .post('Cotacao', 'AtualizarPropostaModal', objSend)
            .then(() => {
              this.aguardeCadastro = false;
              this.$vs.loading.close();
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: `Operação Realizada com sucesso`,
                color: 'success',
              });
              this.$emit('concluido');
              this.buscaDados();
            })
            .catch((error) => {
              this.aguardeCadastro = false;
              this.$vs.loading.close();
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: error,
                color: 'danger',
              });
            });
        } else {
          this.aguardeCadastro = false;
          this.$vs.loading.close();
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Não foi possível editar. Favor conferir os campos.',
            color: 'danger',
          });
        }
      });
    },
    preencheForm() {
      this.form.dadosClientePessoal.associado =
        this.dadosProposta.dadosCliente.associado;
      this.form.dadosClientePessoal.rg_ie =
        this.dadosProposta.dadosCliente.rg_ie;
      this.form.dadosClientePessoal.cpfCnpj =
        this.dadosProposta.dadosCliente.cpf;
      this.form.dadosClientePessoal.cnh = this.dadosProposta.dadosCliente.cnh;
      this.form.dadosClientePessoal.dataVencimentoCnh =
        this.dadosProposta.dadosCliente.dataVencimentoCnh;
      this.form.dadosClientePessoal.email =
        this.dadosProposta.dadosCliente.email;
      this.form.dadosClientePessoal.idProspect =
        this.dadosProposta.dadosCliente.idProspect;

      if (this.dadosProposta.dadosCliente.tipo === 'Pessoa Física') {
        this.form.dadosClientePessoal.dataNascimento =
          this.dadosProposta.dadosCliente.dataNascimento;
      }

      if (this.dadosProposta.dadosCliente.tipo === 'Pessoa Jurídica') {
        this.form.dadosClientePessoal.representanteLegal =
          this.dadosProposta.dadosCliente.representanteLegal;
        this.form.dadosClientePessoal.cpfRepresentante =
          this.dadosProposta.dadosCliente.cpfRepresentante;
      }

      this.form.dadosClienteEndereco.endereco =
        this.dadosProposta.dadosCliente.endereco;
      this.form.dadosClienteEndereco.numero =
        this.dadosProposta.dadosCliente.numero;
      this.form.dadosClienteEndereco.complemento =
        this.dadosProposta.dadosCliente.complemento;
      this.form.dadosClienteEndereco.bairro =
        this.dadosProposta.dadosCliente.bairro;
      this.form.dadosClienteEndereco.idProspect =
        this.dadosProposta.dadosCliente.idProspect;

      this.form.dadosVeiculo.anoExercicioDut =
        this.dadosProposta.dadosVeiculo.anoExercicioDut;
      this.form.dadosVeiculo.renavam = this.dadosProposta.dadosVeiculo.renavam;
      this.form.dadosVeiculo.cor = this.dadosProposta.dadosVeiculo.cor;
      this.form.dadosVeiculo.placa = this.dadosProposta.dadosVeiculo.placa;
      this.form.dadosVeiculo.tipoCambio =
        this.dadosProposta.dadosVeiculo.tipoCambio;
      this.form.dadosVeiculo.numeroMotor =
        this.dadosProposta.dadosVeiculo.numeroMotor;
      this.form.dadosVeiculo.chassi = this.dadosProposta.dadosVeiculo.chassi;
      this.form.dadosVeiculo.idProposta = this.dadosProposta.idProposta;
    },

    ajustaDataHoraUtc(data) {
      return moment.utc(data).local().format('DD/MM/YYYY HH:mm');
    },
    async liberarAguardandoAprovacao() {
      this.$vs.loading();

      const objSend = {
        idStatus: this.dadosProposta.idStatus,
        idProposta: this.dadosProposta.idProposta,
      };

      try {
        await service.post('Cotacao', 'liberar-aguardando-aprovacao', objSend);
        this.buscaDados();
        this.$vs.loading.close();
      } catch (e) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: e,
          color: 'danger',
        });
        this.$vs.loading.close();
      }
    },
    verificaPermissaoUpload() {
      const isEmpresaBp = this.verificaEmpresa();

      // verifica as permissões
      const uploadDuranteAguardandoAprovacao = this.$can(
        'Acesso ao Upload Manual no status Aguardando Aprovação',
        this.subjectPermission,
      );
      const completo = this.$can(
        'Upload Manual Completo',
        this.subjectPermission,
      );
      const documentacao = this.$can(
        'Upload Manual Documentação',
        this.subjectPermission,
      );

      // verifica os status da proposta
      const _idStatusProposta = this.dadosProposta.idStatus;
      const statusPropostaNaoPermiteUpload =
        _idStatusProposta == 2 || _idStatusProposta == 4;

      // const permiteBotaoUploadFixo =
      //   temPermissao && statusPropostaPermiteUpload && isEmpresaBp;

      const permissaoTipoUpload = completo || documentacao;

      // caso não seja um empresa BP o botão não aparece
      if (isEmpresaBp) {
        // Caso o status da proposta seja 'Finalizada' ou 'Recusada', o botão não aparece
        if (statusPropostaNaoPermiteUpload) {
          return false;
        }

        // Caso o usuario não possua a permissão de upload 'Completo' nem 'Manual', o botão não aparece
        else if (!permissaoTipoUpload) {
          return false;
        }

        // Caso o status da cotação seja 'Aguardando Aprovação' verifica a permissão
        // 'Acesso ao Upload Manual no status Aguardando Aprovação'
        else if (_idStatusProposta === 3) {
          return uploadDuranteAguardandoAprovacao;
        }

        // O botão aparece
        else {
          return true;
        }
      }

      return false;
    },
    closeModalUploadManual() {
      this.modalUpload = false;
    },
    validarDadosNaoPreenchidosVistoria(dados, title, icon) {
      this.exibirDetalhesVistoria = true;

      const propriedades = Object.entries(dados);
      const _dadosExibir = {
        title,
        icon,
        propriedades: [],
      };

      propriedades.forEach((item) => {
        const [chave, valor] = item;
        if (valor === null || valor === 'null' || valor === '') {
          const texto = this.desfazCamelCase(chave);
          _dadosExibir.propriedades.push(texto);
        }
      });

      _dadosExibir.key = Math.floor(Math.random() * 100);
      this.itensNaoValidadosVistoria.push(_dadosExibir);
    },
    async obterDetalhesVistoria() {
      try {
        const chave = this.dadosProposta.chave;
        const id = this.dadosProposta.idProposta;
        const idEmpresa = this.dadosProposta.idEmpresa;
        const idGrupo = this.dadosProposta.idGrupo;
        const isZero = this.dadosProposta.isZero;
        const idStatus = this.dadosProposta.idStatus;
        const tipoProposta = this.dadosProposta.tipoProposta;
        const codTipoVeiculo = this.dadosProposta.dadosVeiculo.codTipoVeiculo;
        const somenteAgregado = this.dadosProposta.somenteAgregado;

        const objProposta = {
          tipoProposta,
          codTipoVeiculo,
          somenteAgregado,
        };

        const naoVerificarVistoria = idStatus != 6 && idStatus != 5;

        if (naoVerificarVistoria) {
          return;
        }

        const { data } = await service.post('Vistoria', 'detalhes-vistoria', {
          chave,
          id,
          idEmpresa,
          idGrupo,
          isZero,
        });

        const {
          assinatura,
          dadosCNH,
          dadosEndereco,
          dadosPessoais,
          dadosVeiculos,
          realizarAssinatura,
          validatedDadosCNH,
          validatedDadosEndereco,
          validatedDadosPessoais,
          validatedDadosVeiculos,
          fotos,
          agregado,
          implemento,
          termosPendente,
        } = data;

        const _fotosNaoEnviadas = fotos
          .filter((foto) => foto.nome == null)
          .reduce((acc, item) => {
            const { nomePosicao } = item;

            acc[nomePosicao] = null;
            return acc;
          }, {});

        const temFotosNaoEnviados =
          Object.values(_fotosNaoEnviadas).includes(null);

        if (realizarAssinatura) {
          this.validarDadosNaoPreenchidosVistoria(
            { assinatura },
            'Realizar a assinatura',
            'border_color',
          );
        }

        if (temFotosNaoEnviados) {
          this.validarDadosNaoPreenchidosVistoria(
            _fotosNaoEnviadas,
            'Fotos / Documentos',
            'photo_camera',
          );
        }

        if (!validatedDadosEndereco) {
          const _dadosEndereco = {
            ...objProposta,
            ...dadosEndereco,
          };

          const _dadosSemExcessoes = this.validarExcecoes(_dadosEndereco);
          this.validarDadosNaoPreenchidosVistoria(
            _dadosSemExcessoes,
            'Dados do endereço',
            'home',
          );
        }

        if (!validatedDadosPessoais) {
          const _dadosPessoais = {
            ...objProposta,
            ...dadosPessoais,
          };

          const _dadosSemExcessoes = this.validarExcecoes(_dadosPessoais);

          this.validarDadosNaoPreenchidosVistoria(
            _dadosSemExcessoes,
            'Dados pessoais',
            'assignment_ind',
          );
        }

        if (!validatedDadosVeiculos) {
          const _dadosVeiculos = {
            ...objProposta,
            ...dadosVeiculos,
          };
          const _dadosSemExcessoes = this.validarExcecoes(_dadosVeiculos);
          this.validarDadosNaoPreenchidosVistoria(
            _dadosSemExcessoes,
            'Dados Veiculos / Financeiro',
            'directions_car',
          );
        }

        if (!validatedDadosCNH) {
          const _dadosCNH = {
            ...objProposta,
            ...dadosCNH,
          };
          const _dadosSemExcessoes = this.validarExcecoes(_dadosCNH);

          this.validarDadosNaoPreenchidosVistoria(
            _dadosSemExcessoes,
            'Dados da CNH',
            'contact_mail',
          );
        }

        if (Object.keys(termosPendente).length) {
          this.validarDadosNaoPreenchidosVistoria(
            termosPendente,
            'Termo',
            'assignment_turned_in',
          );
        }

        if (agregado) {
          agregado.forEach((_agregado) => {
            const { validatedForm, ...dadosAgregado } = _agregado;

            if (!validatedForm) {
              this.validarDadosNaoPreenchidosVistoria(
                dadosAgregado,
                `Dados do agregado - ${dadosAgregado.descricao}`,
                'local_shipping',
              );
            }
          });
        }

        if (implemento) {
          implemento.forEach((_implemento) => {
            const { validatedForm, ...dadosImplemento } = _implemento;

            if (!validatedForm) {
              this.validarDadosNaoPreenchidosVistoria(
                dadosImplemento,
                `Dados do implemento - ${dadosImplemento.descricao}`,
                'local_shipping',
              );
            }
          });
        }
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Falha ao buscar os de validação da vistoria, tente novamente',
          color: 'danger',
        });
        this.$vs.loading.close();
      }
    },
    validarExcecoes(dados) {
      const excessoesGeral = [
        'telefone',
        'tipo',
        'representanteLegal',
        'cpfRepresentante',
        'naoPossuiCnh',
      ];
      const excessoesProposta = ['placaSubstituicao'];
      const excessoesCarro = ['cilindradas'];
      const excessoesMoto = ['qtdPortas'];
      const excessoesCaminhao = ['cilindradas'];
      const excessoesComplementos = [
        'qtdPortas',
        'combustivel',
        'km',
        'quantidadePassageiro',
        'estadoPneu',
        'tipoCambio',
        'numeroMotor',
        'codTipoVeiculo',
      ];

      this.deletaExcessoes(excessoesGeral, dados);

      if (dados.tipoProposta !== 'Substituicão') {
        this.deletaExcessoes(excessoesProposta, dados);
      }

      if (dados.codTipoVeiculo && dados.codTipoVeiculo === 2) {
        this.deletaExcessoes(excessoesMoto, dados);
      }

      if (dados.codTipoVeiculo && dados.codTipoVeiculo !== 2) {
        this.deletaExcessoes(excessoesCarro, dados);
        this.deletaExcessoes(excessoesCaminhao, dados);
      }

      if (dados.somenteAgregado || dados.agregado || dados.implemento) {
        this.deletaExcessoes(excessoesComplementos, dados);
      }

      return dados;
    },
    deletaExcessoes(excessoes, objDados) {
      excessoes.forEach((excessao) => delete objDados[excessao]);
    },
    capitalizaTexto(texto) {
      return texto[0].toUpperCase() + texto.substring(1);
    },
    desfazCamelCase(str) {
      if (!str || str == 'CNH') {
        return str;
      }

      let result = str[0].toLowerCase();

      for (let i = 1; i < str.length; i++) {
        if (str[i] === str[i].toUpperCase()) {
          result += ' ';
        }

        result += str[i].toLowerCase();
      }

      return this.capitalizaTexto(result);
    },
    async verificaAssociadoParaUnificiacao() {
      this.abrirModalAssociadoUnificado = false;
      await this.validaCpfUnificacao();
      if (this.necessitaUnificacao == true) {
        this.abrirModalAssociadoUnificado = true;
      } else
        this.openModalVeiculosEmpresaAntiga(
          this.dadosProposta.dadosCliente.idProspect,
          'aprovarVistoria',
        );
    },
    openModalVeiculosEmpresaAntiga(id, acao) {
      if (
        ['118', '119', '120'].includes(this.idEmpresa) &&
        this.$can('Notificar Associado Híbrido', this.subjectPermission)
      ) {
        const obj = { id, acao };
        this.dadosVeiculosEmpresaAntiga = obj;
      } else {
        if (acao == 'aprovarVistoria') this.cotacaoAprovar();
        if (acao == 'listarHibridos')
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Não existe Beneficiário ativo com esse CPF/CNPJ na base antiga',
            color: 'primary',
          });
      }
    },
    retornoModalVeiculosEmpresaAntiga(resposta) {
      this.dadosVeiculosEmpresaAntiga.id = null;
      if (resposta == 'aprovarVistoria') this.cotacaoAprovar();
    },
    validaCpfUnificacao() {
      this.necessitaUnificacao = false;
      this.dadosAssociadoUnificado = null;
      return new Promise((resolve, reject) => {
        let objSend = {};
        this.$vs.loading();
        objSend.idEmpresa = this.dadosProposta.idEmpresa;
        objSend.cpf = this.dadosProposta.dadosCliente.cpf;
        objSend.idProspect = this.dadosProposta.dadosCliente.idProspect;
        service
          .post('Associado', 'verificaCpfAssociadoDuplicado', objSend)
          .then((res) => {
            if (res.data.retorno.length > 0) {
              this.necessitaUnificacao = true;
              this.dadosAssociadoUnificado = res.data.retorno[0];

              if (this.dadosAssociadoUnificado.veiculos)
                this.dadosAssociadoUnificado.veiculos = JSON.parse(
                  this.dadosAssociadoUnificado.veiculos,
                );
            }

            this.$vs.loading.close();
            resolve();
          })
          .catch(() => {
            this.$vs.loading.close();
            reject();
          });
      });
    },
    mostraFoto() {
      let fotos = this.filtraFotos();
      let cnh = fotos.find((x) => x.nomePosicao == 'CNH');
      this.openModalFoto('Foto', cnh);
      this.fecharModalAssociadoUnificado(true);
    },
    unificarAssociados() {
      let objSend = {};
      objSend.idEmpresa = this.dadosProposta.idEmpresa;
      objSend.cpf = this.dadosProposta.dadosCliente.cpf;
      objSend.idProspect = this.dadosProposta.dadosCliente.idProspect;
      objSend.idProposta = this.dadosProposta.idProposta;

      this.$vs.loading();

      service
        .post('Associado', 'unificarAssociados', objSend)
        .then(async () => {
          this.carregando = false;
          this.$vs.loading.close();
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Associado Unificado com Sucesso',
            color: 'success',
          });
          this.fecharModalAssociadoUnificado(true);
          await this.buscaDados();
          this.verificaAssociadoParaUnificiacao();
        })
        .catch((e) => {
          this.carregando = false;
          this.$vs.loading.close();
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
        });
    },
    exibirBotoesDeAceite() {
      const exibirParaResponsavelVistoria =
        this.responsavelVistoria &&
        this.dadosProposta.nomeStatus !== 'Finalizada' &&
        this.dadosProposta.nomeStatus !== 'Recusada';

      const exibirParaAdmin =
        this.isAdmin &&
        this.dadosProposta.nomeStatus !== 'Finalizada' &&
        this.dadosProposta.nomeStatus !== 'Recusada';

      return exibirParaResponsavelVistoria || exibirParaAdmin;
    },

    /**
     * Uploads a PDF document for the contract.
     *
     * @async
     * @function
     * @throws {Error} If there is an error during the PDF upload process.
     * @returns {Promise<void>} Resolves when the PDF is successfully uploaded.
     */
    async uploadPdfContrato() {
      const objSend = {
        url:
          window.location.origin +
          '/contratoAdesao/' +
          this.dadosProposta.chave,
        tipoDocumento: 'Contrato',
        idEmpresa: this.idEmpresa,
        idProposta: this.dadosProposta.idProposta,
        idAssociado: this.dadosProposta.dadosCliente.idProspect,
        dataAceite: this.dadosProposta.dataAceite,
        chave: this.dadosProposta.chave,
      };
      try {
        await service.post('Termos', 'upload-pdf', objSend);
      } catch (e) {
        throw new Error(e);
      }
    },
    async handleFiles(files) {
      this.files = files;
      await this.uploadAWS();
    },
    async uploadAWS() {
      try {
        const formDataSend = new FormData();

        this.files.forEach((file) => {
          formDataSend.append('files', file);
        });

        this.$vs.loading();

        const { uploadedFiles } = await service.uploadAll(
          'upload-multi',
          'Eventos/' + this.idEvento,
          formDataSend,
        );

        await this.uploadFotos(uploadedFiles);
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
    async uploadFotos(awsLinks) {
      try {
        const fotos = this.files.map((f, index) => {
          return {
            idEvento: this.idEvento,
            nome: awsLinks[index],
            legenda: f.name.split('.')[0],
            idFotoReferente: this.idReferente,
            uploadBy: this.idUsuario,
          };
        });

        const result = await service.post(
          'eventos2',
          'registrar-fotos-documentos',
          fotos,
        );

        // POG
        setTimeout(() => {
          this.fotosCroqui = this.ordenarDecrescente(result.data);
        }, 500);

        notify.notifySuccess(
          this.$vs,
          'Upload das fotos concluído com sucesso!',
        );

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },

    async softDeleteImg() {
      this.$vs.loading();
      this.itemDeletado.motivoExclusao = this.motivoExclusao;
      try {
        await service.post('Vistoria', 'deletarArquivo', this.itemDeletado);
        this.activePromptDelete = false;
        this.itemDeletado = null;
        this.motivoExclusao = null;
        this.openModal = false;
        this.buscaFotos();
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: error,
          color: 'danger',
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    showDeletedImgs() {
      this.modalDeletedImgs = true;
    },
    closeDeletedImgs() {
      this.modalDeletedImgs = false;
    },

    /**
     * Busca todas as outras propostas que não estejam no status 'Finalizada' ou 'Recusada' com a mesma placa ou chassi da proposta em análise
     * Persiste o resultado no estado listPropostasConcorrentes
     */
    async buscaPropostasConcorrentes() {
      try {
        this.$vs.loading();
        const objSend = {
          idEmpresa: this.dadosProposta.idEmpresa,
          idProposta: this.dadosProposta.idProposta,
          placa: this.dadosProposta.dadosVeiculo.placa,
          chassi: this.dadosProposta.dadosVeiculo.chassi,
        };
        const propostasConcorrentesResult = await service.post(
          'Cotacao',
          'buscar-propostas-concorrentes',
          objSend,
        );
        this.listPropostasConcorrentes = propostasConcorrentesResult.data;
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },

    /**
     * Busca todas as outras propostas que não estejam no status 'Finalizada' ou 'Recusada' com a mesma placa ou chassi da proposta em análise
     * Altera o status das outras propostas concorrentes para 'Recusada'
     */
    async recusaPropostasConcorrentes() {
      try {
        this.$vs.loading();
        const objSend = {
          idEmpresa: this.dadosProposta.idEmpresa,
          idProposta: this.dadosProposta.idProposta,
          placa: this.dadosProposta.dadosVeiculo.placa,
          chassi: this.dadosProposta.dadosVeiculo.chassi,
        };
        const recusaPropostasConcorrentesResult = await service.post(
          'Cotacao',
          'recusar-propostas-concorrentes',
          objSend,
        );
        return recusaPropostasConcorrentesResult;
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },

    /**
     * Abre em uma nova janela de Detalhes da Vistoria a proposta concorrente selecionada
     */
    abreNovaJanelaProposta(idProposta) {
      const currentUrl = window.location.href;
      const novaUrl = currentUrl.replace(
        /\/detalheVistoria\/\d+/,
        `/detalheVistoria/${idProposta}`,
      );
      window.open(novaUrl, '_blank');
    },
    async buscaDadosEmpresa() {
      try {
        this.$vs.loading();
        const token = localStorage.getItem('user-token');
        const decoded = jwt.decode(token);
        this.form.idEmpresa = decoded.id_empresa;
        const { data } = await service.getAll(
          'g',
          {},
          `empresas/list/idEmpresa/${this.form.idEmpresa}`,
        );

        const _data = decryptData(data);
        const [resultEmpresa] = _data;

        this.exigirCampoEstacionamentoProposta =
          resultEmpresa.exigirCampoEstacionamentoProposta;
      } catch (error) {
        this.erroConexao =
          'Seu aplicativo parece estar offline, verifique sua conexão';
        throw error;
      } finally {
        this.$vs.loading.close();
      }
    },
  },

  async created() {
    this.verificaAdmin();
    this.idEmpresa = localStorage.getItem('idEmpresa');

    await this.buscaDados();
    await this.buscaFotos();
    await this.buscaDadosEmpresa();
  },
  async mounted() {
    this.buscarDicionarioChassisNacionais();
    this.buscaDadosFinanceiros();
    this.buscaCoresECombustivel();
    await this.translate(this.idEmpresa)
  },
  components: {
    VueJsonPretty,
    vSelect,
    formUploadVistoria,
    formSituacaoFinanceira,
    ModalVeiculosEmpresaAntiga,
    ModalAssociadoUnificado,
    flatPickr,
    FormMensagemVistoria,
    ModalListImgs,
  },
};
</script>
<style scoped lang="scss">
.uppercase {
  text-transform: uppercase;
}
.pop-up-fullscreen {
  position: relative;
  top: -10px;
  right: 15px;
  float: right;
}
.assinatura {
  max-width: 100%;
  max-height: 200px;
}
.foto {
  cursor: pointer;
}
@media (max-width: 1161px) {
  .video {
    max-height: 100px !important;
  }
}
@media (max-width: 1395px) {
  .video {
    max-height: 110px !important;
  }
}

.table-bordered {
  display: table;
  border-collapse: separate;
  box-sizing: border-box;
  border-spacing: 2px;
  border-color: grey;
  width: 100%;
  tr td {
    padding: 2px;
  }
  tr:nth-child(2n) {
    background: #efefef !important;
  }
}
</style>

<style lang="scss">
@media screen {
  .printer {
    display: none;
  }
}
@media print {
  .table-bordered {
    tr:nth-child(2n) {
      background-color: #ffffff !important;
    }
  }
  .non-printer {
    display: none;
  }
  .vue-back-to-top {
    display: none !important;
  }
  .folha {
    padding: 20px 0 0 0;
    page-break-after: always;
  }
  .btn-print {
    display: none;
  }
  #content-area {
    margin-left: 0px;
  }
  .navbar-sticky .router-view .router-content {
    margin-top: 0px;
  }
  .vs-content-sidebar,
  .router-header,
  .con-pagination-table,
  #data-list-list-view .vs-con-table .vs-table--header,
  .the-footer,
  .vs-navbar {
    display: none !important;
  }
  body,
  .vs-con-table .vs-con-tbody {
    background-color: #ffffff;
  }
  .vx-card,
  #data-list-list-view .vs-con-table .vs-table tr {
    box-shadow: none !important;
  }
  .con-vs-popup {
    .vs-popup {
      width: 1000px !important;
    }
  }

  .vs-popup-content {
    width: 900px !important; //You can change the width according to your content
    height: auto;
  }

  .con-vs-popup .vs-popup {
    width: 70% !important;
  }

  .td-check {
    visibility: hidden;
  }
  .detalheProposta {
    .vs-col {
      width: 100% !important;
    }
    .filtroFotos {
      display: none !important;
    }
    .cardFotos {
      width: 60% !important;
      img {
        height: 100%;
      }
      footer {
        display: none !important;
      }
    }
    h3 {
      button {
        display: none !important;
      }
    }
  }
}
.box {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.input-data-ativacao {
  width: 100%;
}
</style>
